import React from "react";
/** @deprecated  */
export const FigmaSvgIcon = ({
  color = "currentColor",
  size = "15",
  type,
  className,
  width = "",
  height = "",
}) => {
  const renderIcon = () => {
    switch (type) {
      case "delete":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-4 h-4 "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        );

      // case "avatar":
      //     return()

      case "down-arrow":
        return (
          <svg
            // className={className}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.5 6.75L9 11.25L13.5 6.75"
              stroke="#4B465C"
              stroke-width="1.125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.5 6.75L9 11.25L13.5 6.75"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "down-arrow-bold":
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="#7E7E7E"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "graph":
        return (
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 9.5V11C21 15.714 21 18.071 19.535 19.535C18.072 21 15.714 21 11 21C6.286 21 3.929 21 2.464 19.535C1 18.072 1 15.714 1 11C1 6.286 1 3.929 2.464 2.464C3.93 1 6.286 1 11 1H12.5"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M18 7C19.6569 7 21 5.65685 21 4C21 2.34315 19.6569 1 18 1C16.3431 1 15 2.34315 15 4C15 5.65685 16.3431 7 18 7Z"
              stroke={color}
              stroke-width="1.5"
            />
            <path
              d="M6 13L8.293 10.707C8.48053 10.5195 8.73484 10.4142 9 10.4142C9.26516 10.4142 9.51947 10.5195 9.707 10.707L11.293 12.293C11.4805 12.4805 11.7348 12.5858 12 12.5858C12.2652 12.5858 12.5195 12.4805 12.707 12.293L16 9M16 9V11.5M16 9H13.5"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "dashboard-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1598_29314)">
              <path
                d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z"
                fill={color}
              />
            </g>
            <defs>
              <clipPath id="clip0_1598_29314">
                <rect width={size} height={size} fill="white" />
              </clipPath>
            </defs>
          </svg>
        );

      case "driver-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 5.5C10.5 5.36739 10.5527 5.24021 10.6464 5.14645C10.7402 5.05268 10.8674 5 11 5H13C13.1326 5 13.2598 5.05268 13.3536 5.14645C13.4473 5.24021 13.5 5.36739 13.5 5.5C13.5 5.63261 13.4473 5.75979 13.3536 5.85355C13.2598 5.94732 13.1326 6 13 6H11C10.8674 6 10.7402 5.94732 10.6464 5.85355C10.5527 5.75979 10.5 5.63261 10.5 5.5Z"
              fill="#7E7E7E"
              stroke={color}
              stroke-width="0.5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.6813 9.26C16.4998 9.4025 16.2643 9.5165 15.9803 9.609C15.993 9.73767 15.9993 9.868 15.9993 10C15.9991 10.5416 15.8889 11.0776 15.6753 11.5753C15.4618 12.0731 15.1494 12.5223 14.7571 12.8958C14.3648 13.2692 13.9007 13.559 13.393 13.7478C12.8853 13.9365 12.3446 14.0201 11.8036 13.9936C11.2626 13.9671 10.7326 13.831 10.2458 13.5936C9.75899 13.3561 9.32546 13.0223 8.97152 12.6123C8.61757 12.2023 8.35058 11.7247 8.18673 11.2085C8.02287 10.6922 7.96557 10.1481 8.0183 9.609C7.7343 9.5165 7.4988 9.4025 7.3178 9.26C7.0828 9.075 6.9253 8.828 6.9068 8.531C6.8893 8.2555 6.9983 8.0215 7.1073 7.8565C7.21486 7.70018 7.34263 7.55878 7.4873 7.436C7.55797 7.37467 7.62564 7.32017 7.6903 7.2725C7.67097 7.1695 7.65064 7.04617 7.6293 6.9025C7.54118 6.27219 7.49774 5.63644 7.4993 5C7.4993 4.843 7.5663 4.726 7.5973 4.6765C7.6363 4.614 7.6823 4.5605 7.7243 4.5175C7.8078 4.43 7.9158 4.341 8.0343 4.2555C8.2743 4.0815 8.6043 3.886 8.9963 3.703C9.7778 3.338 10.8513 3 11.9993 3C13.1473 3 14.2208 3.3385 15.0023 3.703C15.3393 3.85706 15.6614 4.04202 15.9643 4.2555C16.0828 4.341 16.1908 4.4305 16.2743 4.5175C16.3163 4.5605 16.3623 4.614 16.4013 4.6765C16.4323 4.726 16.4993 4.843 16.4993 5C16.4993 5.801 16.4343 6.45 16.3693 6.9025C16.348 7.0465 16.3276 7.16983 16.3083 7.2725C16.3723 7.32 16.4418 7.3745 16.5118 7.436C16.6368 7.5455 16.7798 7.688 16.8913 7.8565C17.0008 8.0215 17.1093 8.2555 17.0923 8.5315C17.0738 8.828 16.9163 9.075 16.6813 9.26ZM8.5003 5.159C8.5078 5.833 8.5638 6.378 8.6193 6.759C8.63264 6.849 8.6453 6.92933 8.6573 7H15.3413C15.3536 6.929 15.3663 6.84867 15.3793 6.759C15.4343 6.378 15.4908 5.833 15.4983 5.159C15.4593 5.12614 15.4192 5.09479 15.3778 5.065C15.1973 4.9345 14.9233 4.77 14.5793 4.6095C13.8878 4.2865 12.9613 4 11.9993 4C11.0373 4 10.1108 4.2865 9.4193 4.6095C9.0753 4.77 8.8013 4.9345 8.6213 5.0645C8.57976 5.0946 8.5394 5.12629 8.5003 5.1595M8.3933 8L8.3918 8.001C8.30548 8.05847 8.22282 8.12126 8.1443 8.189C8.0553 8.267 7.9843 8.343 7.9413 8.409C7.9313 8.42399 7.92212 8.43952 7.9138 8.4555L7.9358 8.474C8.0108 8.533 8.1718 8.6195 8.4858 8.705C8.5478 8.72167 8.6143 8.738 8.6853 8.754L8.6898 8.755C8.9408 8.8105 9.2498 8.86 9.6263 8.899C10.1598 8.9545 10.8313 8.991 11.6703 8.999L11.9993 9C13.6128 9 14.6563 8.8995 15.3093 8.755L15.3133 8.754C15.3846 8.73833 15.4513 8.722 15.5133 8.705C15.8268 8.62 15.9883 8.533 16.0628 8.474L16.0848 8.4555C16.0766 8.43953 16.0676 8.42401 16.0578 8.409C15.9994 8.32745 15.9311 8.25354 15.8543 8.189C15.7759 8.12128 15.6934 8.05849 15.6073 8.001L15.6053 8H8.3933ZM11.8633 10C13.1843 10 14.2083 9.93 14.9933 9.808C14.9973 9.87133 14.9993 9.93533 14.9993 10C14.9989 10.4004 14.9185 10.7966 14.7626 11.1654C14.6067 11.5342 14.3786 11.868 14.0916 12.1473C13.8047 12.4265 13.4648 12.6455 13.0919 12.7913C12.7191 12.9371 12.3208 13.0068 11.9205 12.9963C11.5203 12.9858 11.1262 12.8953 10.7615 12.7301C10.3968 12.5649 10.0689 12.3284 9.79699 12.0345C9.52512 11.7405 9.31484 11.3952 9.17852 11.0187C9.04221 10.6423 8.98264 10.2423 9.0033 9.8425C9.7348 9.9435 10.6723 10 11.8633 10ZM8.0383 19.4385C8.01213 19.6245 7.9991 19.8121 7.9993 20V20.5C7.99936 20.6099 7.96319 20.7168 7.8964 20.8041C7.82961 20.8914 7.73591 20.9542 7.62981 20.9829C7.5237 21.0116 7.4111 21.0045 7.30942 20.9628C7.20774 20.9211 7.12264 20.847 7.0673 20.752C6.73016 20.9343 6.33603 20.9806 5.9658 20.8815L4.9998 20.6225C4.61568 20.5194 4.28823 20.268 4.08946 19.9235C3.89068 19.579 3.83685 19.1697 3.9398 18.7855L4.3278 17.3365C4.4308 16.9523 4.6822 16.6247 5.02669 16.4258C5.37119 16.227 5.78057 16.1731 6.1648 16.276L7.1308 16.5345C7.4668 16.6245 7.7458 16.822 7.9398 17.08C8.40275 16.4358 9.01247 15.9112 9.71848 15.5494C10.4245 15.1877 11.2065 14.9994 11.9998 15C12.7927 14.9996 13.5742 15.1879 14.2799 15.5495C14.9855 15.911 15.5949 16.4353 16.0578 17.079C16.2591 16.8128 16.5435 16.6214 16.8658 16.535L17.8318 16.2765C18.216 16.1735 18.6253 16.2274 18.9698 16.4262C19.3143 16.6249 19.5657 16.9524 19.6688 17.3365L20.0573 18.786C20.1083 18.9763 20.1212 19.1747 20.0955 19.37C20.0698 19.5653 20.0058 19.7537 19.9073 19.9242C19.8088 20.0948 19.6776 20.2443 19.5213 20.3642C19.365 20.4841 19.1866 20.5721 18.9963 20.623L18.0308 20.8815C17.6612 20.9807 17.2677 20.9349 16.9308 20.7535C16.8753 20.8483 16.7901 20.9222 16.6883 20.9638C16.5866 21.0053 16.474 21.0122 16.368 20.9834C16.262 20.9545 16.1684 20.8915 16.1018 20.8041C16.0351 20.7168 15.9991 20.6099 15.9993 20.5V20C15.9995 19.8121 15.9865 19.6245 15.9603 19.4385L13.3583 20.136C13.2375 20.3945 13.0455 20.6132 12.8048 20.7665C12.5641 20.9197 12.2846 21.0011 11.9993 21.0011C11.714 21.0011 11.4345 20.9197 11.1938 20.7665C10.9531 20.6132 10.7611 20.3945 10.6403 20.136L8.0383 19.4385ZM10.5593 19.0785C10.6262 18.8504 10.7462 18.6415 10.9097 18.4689C11.0731 18.2964 11.2752 18.1651 11.4993 18.086V16.031C10.798 16.1197 10.1327 16.3925 9.57089 16.8215C9.00911 17.2506 8.57091 17.8207 8.3008 18.474L10.5593 19.0785ZM15.6978 18.4735C15.4276 17.8203 14.9894 17.2503 14.4276 16.8213C13.8659 16.3923 13.2006 16.1197 12.4993 16.031V18.0855C12.9513 18.2455 13.3043 18.6155 13.4393 19.079L15.6978 18.4735ZM16.7713 18.1135C16.7543 18.0501 16.7499 17.9839 16.7585 17.9188C16.7671 17.8537 16.7884 17.7909 16.8212 17.734C16.854 17.6771 16.8977 17.6273 16.9498 17.5873C17.0019 17.5473 17.0614 17.518 17.1248 17.501L18.0908 17.242C18.2188 17.2078 18.3552 17.2258 18.47 17.2921C18.5847 17.3584 18.6685 17.4675 18.7028 17.5955L19.0913 19.0445C19.1083 19.1079 19.1127 19.1741 19.1041 19.2392C19.0956 19.3043 19.0743 19.3671 19.0414 19.424C19.0086 19.4809 18.9649 19.5307 18.9128 19.5707C18.8607 19.6107 18.8012 19.64 18.7378 19.657L17.7718 19.916C17.7083 19.933 17.6421 19.9373 17.577 19.9287C17.5119 19.9202 17.4491 19.8988 17.3922 19.8659C17.3353 19.8331 17.2855 19.7893 17.2455 19.7371C17.2055 19.685 17.1762 19.6255 17.1593 19.562L16.7713 18.1135ZM5.9063 17.242C5.84284 17.2249 5.77663 17.2205 5.71146 17.229C5.6463 17.2375 5.58345 17.2588 5.52651 17.2917C5.46958 17.3245 5.41968 17.3682 5.37966 17.4204C5.33964 17.4725 5.3103 17.532 5.2933 17.5955L4.9053 19.044C4.88829 19.1074 4.88393 19.1736 4.89249 19.2387C4.90105 19.3038 4.92235 19.3666 4.95518 19.4235C4.988 19.4804 5.03171 19.5302 5.08381 19.5702C5.13591 19.6102 5.19537 19.6395 5.2588 19.6565L6.2248 19.9155C6.28823 19.9325 6.35439 19.9369 6.4195 19.9283C6.48461 19.9198 6.5474 19.8985 6.60428 19.8656C6.66115 19.8328 6.71101 19.7891 6.75099 19.737C6.79097 19.6849 6.8203 19.6254 6.8373 19.562L7.2253 18.113C7.24239 18.0495 7.2468 17.9833 7.23828 17.9182C7.22976 17.853 7.20847 17.7901 7.17564 17.7332C7.14281 17.6763 7.09907 17.6264 7.04694 17.5864C6.9948 17.5463 6.93529 17.517 6.8718 17.5L5.9063 17.242ZM12.4993 19.5C12.4993 19.6326 12.4466 19.7598 12.3529 19.8536C12.2591 19.9473 12.1319 20 11.9993 20C11.8667 20 11.7395 19.9473 11.6457 19.8536C11.552 19.7598 11.4993 19.6326 11.4993 19.5C11.4993 19.3674 11.552 19.2402 11.6457 19.1464C11.7395 19.0527 11.8667 19 11.9993 19C12.1319 19 12.2591 19.0527 12.3529 19.1464C12.4466 19.2402 12.4993 19.3674 12.4993 19.5Z"
              fill={color}
            />
            <path
              d="M8.5003 5.159C8.5078 5.833 8.5638 6.378 8.6193 6.759C8.63264 6.849 8.6453 6.92933 8.6573 7H15.3413C15.3536 6.929 15.3663 6.84867 15.3793 6.759C15.4343 6.378 15.4908 5.833 15.4983 5.159C15.4593 5.12614 15.4192 5.09479 15.3778 5.065C15.1973 4.9345 14.9233 4.77 14.5793 4.6095C13.8878 4.2865 12.9613 4 11.9993 4C11.0373 4 10.1108 4.2865 9.4193 4.6095C9.0753 4.77 8.8013 4.9345 8.6213 5.0645C8.57976 5.0946 8.5394 5.12629 8.5003 5.1595M16.6813 9.26C16.4998 9.4025 16.2643 9.5165 15.9803 9.609C15.993 9.73767 15.9993 9.868 15.9993 10C15.9991 10.5416 15.8889 11.0776 15.6753 11.5753C15.4618 12.0731 15.1494 12.5223 14.7571 12.8958C14.3648 13.2692 13.9007 13.559 13.393 13.7478C12.8853 13.9365 12.3446 14.0201 11.8036 13.9936C11.2626 13.9671 10.7326 13.831 10.2458 13.5936C9.75899 13.3561 9.32546 13.0223 8.97152 12.6123C8.61757 12.2023 8.35058 11.7247 8.18673 11.2085C8.02287 10.6922 7.96557 10.1481 8.0183 9.609C7.7343 9.5165 7.4988 9.4025 7.3178 9.26C7.0828 9.075 6.9253 8.828 6.9068 8.531C6.8893 8.2555 6.9983 8.0215 7.1073 7.8565C7.21486 7.70018 7.34263 7.55878 7.4873 7.436C7.55797 7.37467 7.62564 7.32017 7.6903 7.2725C7.67097 7.1695 7.65064 7.04617 7.6293 6.9025C7.54118 6.27219 7.49774 5.63644 7.4993 5C7.4993 4.843 7.5663 4.726 7.5973 4.6765C7.6363 4.614 7.6823 4.5605 7.7243 4.5175C7.8078 4.43 7.9158 4.341 8.0343 4.2555C8.2743 4.0815 8.6043 3.886 8.9963 3.703C9.7778 3.338 10.8513 3 11.9993 3C13.1473 3 14.2208 3.3385 15.0023 3.703C15.3393 3.85706 15.6614 4.04202 15.9643 4.2555C16.0828 4.341 16.1908 4.4305 16.2743 4.5175C16.3163 4.5605 16.3623 4.614 16.4013 4.6765C16.4323 4.726 16.4993 4.843 16.4993 5C16.4993 5.801 16.4343 6.45 16.3693 6.9025C16.348 7.0465 16.3276 7.16983 16.3083 7.2725C16.3723 7.32 16.4418 7.3745 16.5118 7.436C16.6368 7.5455 16.7798 7.688 16.8913 7.8565C17.0008 8.0215 17.1093 8.2555 17.0923 8.5315C17.0738 8.828 16.9163 9.075 16.6813 9.26ZM8.3933 8L8.3918 8.001C8.30548 8.05847 8.22282 8.12126 8.1443 8.189C8.0553 8.267 7.9843 8.343 7.9413 8.409C7.9313 8.42399 7.92212 8.43952 7.9138 8.4555L7.9358 8.474C8.0108 8.533 8.1718 8.6195 8.4858 8.705C8.5478 8.72167 8.6143 8.738 8.6853 8.754L8.6898 8.755C8.9408 8.8105 9.2498 8.86 9.6263 8.899C10.1598 8.9545 10.8313 8.991 11.6703 8.999L11.9993 9C13.6128 9 14.6563 8.8995 15.3093 8.755L15.3133 8.754C15.3846 8.73833 15.4513 8.722 15.5133 8.705C15.8268 8.62 15.9883 8.533 16.0628 8.474L16.0848 8.4555C16.0766 8.43953 16.0676 8.424 16.0578 8.409C15.9994 8.32745 15.9311 8.25354 15.8543 8.189C15.7759 8.12128 15.6934 8.05849 15.6073 8.001L15.6053 8H8.3933ZM11.8633 10C13.1843 10 14.2083 9.93 14.9933 9.808C14.9973 9.87133 14.9993 9.93533 14.9993 10C14.9989 10.4004 14.9185 10.7966 14.7626 11.1654C14.6067 11.5342 14.3786 11.868 14.0916 12.1473C13.8047 12.4265 13.4648 12.6455 13.0919 12.7913C12.7191 12.9371 12.3208 13.0068 11.9205 12.9963C11.5203 12.9858 11.1262 12.8953 10.7615 12.7301C10.3968 12.5649 10.0689 12.3284 9.79699 12.0345C9.52512 11.7405 9.31484 11.3952 9.17852 11.0187C9.04221 10.6423 8.98264 10.2423 9.0033 9.8425C9.7348 9.9435 10.6723 10 11.8633 10ZM8.0383 19.4385C8.01213 19.6245 7.9991 19.8121 7.9993 20V20.5C7.99936 20.6099 7.96319 20.7168 7.8964 20.8041C7.82961 20.8914 7.73591 20.9542 7.62981 20.9829C7.5237 21.0116 7.4111 21.0045 7.30942 20.9628C7.20774 20.9211 7.12264 20.847 7.0673 20.752C6.73016 20.9343 6.33603 20.9806 5.9658 20.8815L4.9998 20.6225C4.61568 20.5194 4.28823 20.268 4.08946 19.9235C3.89068 19.579 3.83685 19.1697 3.9398 18.7855L4.3278 17.3365C4.4308 16.9523 4.6822 16.6247 5.02669 16.4258C5.37119 16.227 5.78057 16.1731 6.1648 16.276L7.1308 16.5345C7.4668 16.6245 7.7458 16.822 7.9398 17.08C8.40275 16.4358 9.01246 15.9112 9.71848 15.5494C10.4245 15.1877 11.2065 14.9994 11.9998 15C12.7927 14.9996 13.5742 15.1879 14.2799 15.5495C14.9855 15.911 15.5949 16.4353 16.0578 17.079C16.2591 16.8128 16.5435 16.6214 16.8658 16.535L17.8318 16.2765C18.216 16.1735 18.6253 16.2274 18.9698 16.4262C19.3143 16.6249 19.5657 16.9524 19.6688 17.3365L20.0573 18.786C20.1083 18.9763 20.1212 19.1747 20.0955 19.37C20.0698 19.5653 20.0058 19.7537 19.9073 19.9242C19.8088 20.0948 19.6776 20.2443 19.5213 20.3642C19.365 20.4841 19.1866 20.5721 18.9963 20.623L18.0308 20.8815C17.6612 20.9807 17.2677 20.9349 16.9308 20.7535C16.8753 20.8483 16.7901 20.9222 16.6883 20.9638C16.5866 21.0053 16.474 21.0122 16.368 20.9834C16.262 20.9545 16.1684 20.8915 16.1018 20.8041C16.0351 20.7168 15.9991 20.6099 15.9993 20.5V20C15.9995 19.8121 15.9865 19.6245 15.9603 19.4385L13.3583 20.136C13.2375 20.3945 13.0455 20.6132 12.8048 20.7665C12.5641 20.9197 12.2846 21.0011 11.9993 21.0011C11.714 21.0011 11.4345 20.9197 11.1938 20.7665C10.9531 20.6132 10.7611 20.3945 10.6403 20.136L8.0383 19.4385ZM10.5593 19.0785C10.6262 18.8504 10.7462 18.6415 10.9097 18.4689C11.0731 18.2964 11.2752 18.1651 11.4993 18.086V16.031C10.798 16.1197 10.1327 16.3925 9.57089 16.8215C9.00911 17.2506 8.57091 17.8207 8.3008 18.474L10.5593 19.0785ZM15.6978 18.4735C15.4276 17.8203 14.9894 17.2503 14.4276 16.8213C13.8659 16.3923 13.2006 16.1197 12.4993 16.031V18.0855C12.9513 18.2455 13.3043 18.6155 13.4393 19.079L15.6978 18.4735ZM16.7713 18.1135C16.7543 18.0501 16.7499 17.9839 16.7585 17.9188C16.7671 17.8537 16.7884 17.7909 16.8212 17.734C16.854 17.6771 16.8977 17.6273 16.9498 17.5873C17.0019 17.5473 17.0614 17.518 17.1248 17.501L18.0908 17.242C18.2188 17.2078 18.3552 17.2258 18.47 17.2921C18.5847 17.3584 18.6685 17.4675 18.7028 17.5955L19.0913 19.0445C19.1083 19.1079 19.1127 19.1741 19.1041 19.2392C19.0956 19.3043 19.0743 19.3671 19.0414 19.424C19.0086 19.4809 18.9649 19.5307 18.9128 19.5707C18.8607 19.6107 18.8012 19.64 18.7378 19.657L17.7718 19.916C17.7083 19.933 17.6421 19.9373 17.577 19.9287C17.5119 19.9202 17.4491 19.8988 17.3922 19.8659C17.3353 19.8331 17.2855 19.7893 17.2455 19.7371C17.2055 19.685 17.1762 19.6255 17.1593 19.562L16.7713 18.1135ZM5.9063 17.242C5.84284 17.2249 5.77663 17.2205 5.71146 17.229C5.6463 17.2375 5.58345 17.2588 5.52651 17.2917C5.46958 17.3245 5.41968 17.3682 5.37966 17.4204C5.33964 17.4725 5.3103 17.532 5.2933 17.5955L4.9053 19.044C4.88829 19.1074 4.88393 19.1736 4.89249 19.2387C4.90105 19.3038 4.92235 19.3666 4.95518 19.4235C4.988 19.4804 5.03171 19.5302 5.08381 19.5702C5.13591 19.6102 5.19537 19.6395 5.2588 19.6565L6.2248 19.9155C6.28823 19.9325 6.35439 19.9369 6.4195 19.9283C6.48461 19.9198 6.5474 19.8985 6.60428 19.8656C6.66115 19.8328 6.71101 19.7891 6.75099 19.737C6.79097 19.6849 6.8203 19.6254 6.8373 19.562L7.2253 18.113C7.24239 18.0495 7.2468 17.9833 7.23828 17.9182C7.22976 17.853 7.20847 17.7901 7.17564 17.7332C7.14281 17.6763 7.09907 17.6264 7.04694 17.5864C6.9948 17.5463 6.93529 17.517 6.8718 17.5L5.9063 17.242ZM12.4993 19.5C12.4993 19.6326 12.4466 19.7598 12.3529 19.8536C12.2591 19.9473 12.1319 20 11.9993 20C11.8667 20 11.7395 19.9473 11.6457 19.8536C11.552 19.7598 11.4993 19.6326 11.4993 19.5C11.4993 19.3674 11.552 19.2402 11.6457 19.1464C11.7395 19.0527 11.8667 19 11.9993 19C12.1319 19 12.2591 19.0527 12.3529 19.1464C12.4466 19.2402 12.4993 19.3674 12.4993 19.5Z"
              stroke={color}
              stroke-width="0.5"
            />
          </svg>
        );

      case "fleet-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1924_8614)">
              <path
                d="M4.94551 4.5C3.94351 4.5 3.01801 5.001 2.46076 5.83575L0.375013 8.9535C0.129547 9.32112 -0.000991196 9.75346 1.28833e-05 10.1955V15.1642C-0.00136999 15.4972 0.108609 15.821 0.312459 16.0843C0.516309 16.3475 0.802323 16.535 1.12501 16.617L3.07051 17.1097C3.21043 17.7838 3.57792 18.3892 4.11133 18.8245C4.64473 19.2597 5.31159 19.4982 6.00001 19.5C7.38901 19.5 8.54851 18.5393 8.88301 17.25H15.867C16.2015 18.5393 17.361 19.5 18.75 19.5C20.139 19.5 21.2985 18.5393 21.633 17.25H22.5C23.3205 17.25 24 16.5705 24 15.75V13.008C23.999 12.3396 23.7748 11.6906 23.363 11.1641C22.9512 10.6376 22.3753 10.2637 21.7268 10.1017L17.6715 9.0705L14.742 5.5785C14.4616 5.24148 14.1106 4.97019 13.7137 4.78383C13.3169 4.59746 12.8839 4.50057 12.4455 4.5H4.94551ZM4.94551 6H8.25001V9H2.15626L3.70351 6.6795V6.65625C3.83925 6.45201 4.02393 6.28497 4.24072 6.17035C4.45752 6.05573 4.7003 5.99717 4.94551 6ZM9.75001 6H12.4455C12.8903 6 13.3095 6.1965 13.5938 6.53925L15.6563 9H9.75001V6ZM1.50001 10.5H17.1563L21.375 11.5545C21.6987 11.6348 21.9859 11.822 22.1901 12.0858C22.3942 12.3496 22.5034 12.6745 22.5 13.008V15.75H21.633C21.2985 14.4607 20.139 13.5 18.75 13.5C17.361 13.5 16.2015 14.4607 15.867 15.75H8.88301C8.54851 14.4607 7.38901 13.5 6.00001 13.5C4.67026 13.5 3.55351 14.379 3.16426 15.5858L1.50001 15.165V10.5ZM6.00001 15C6.83776 15 7.50001 15.6622 7.50001 16.5C7.50001 17.3378 6.83776 18 6.00001 18C5.16226 18 4.50001 17.3378 4.50001 16.5C4.50001 15.6622 5.16226 15 6.00001 15ZM18.75 15C19.5878 15 20.25 15.6622 20.25 16.5C20.25 17.3378 19.5878 18 18.75 18C17.9123 18 17.25 17.3378 17.25 16.5C17.25 15.6622 17.9123 15 18.75 15Z"
                fill={color}
              />
            </g>
            <defs>
              <clipPath id="clip0_1924_8614">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );

      case "list-icon":
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 4V7.66661C2 8.66476 2.42461 9.62203 3.18043 10.3278C3.93624 11.0336 4.96134 11.4301 6.03023 11.4301H17.999M13.731 16L17.5567 12.4275C17.6972 12.2964 17.8086 12.1408 17.8847 11.9695C17.9608 11.7982 18 11.6146 18 11.4292M13.732 6.85934L17.5567 10.4328C17.8519 10.7085 18 11.0698 18 11.4311"
              stroke="#7E7E7E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "request-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 8V13C3 16.771 3.001 18.656 4.172 19.828C5.343 21 7.229 21 11 21H13C16.771 21 18.656 20.999 19.828 19.828C21 18.657 21 16.771 21 13V8M3 8H21M3 8L3.865 6.077C4.537 4.585 4.872 3.84 5.552 3.42C6.232 3 7.105 3 8.85 3H15.15C16.895 3 17.767 3 18.448 3.42C19.128 3.84 19.463 4.585 20.135 6.077L21 8M12 8V3"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.5 13.5H14C14.5304 13.5 15.0391 13.7107 15.4142 14.0858C15.7893 14.4609 16 14.9696 16 15.5C16 16.0304 15.7893 16.5391 15.4142 16.9142C15.0391 17.2893 14.5304 17.5 14 17.5H13M10 11.5L8 13.5L10 15.5"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "recovery-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.0019 21C17.5323 21 18.041 20.7893 18.4161 20.4142C18.7911 20.0391 19.0019 19.5304 19.0019 19C19.0019 18.4696 18.7911 17.9609 18.4161 17.5858C18.041 17.2107 17.5323 17 17.0019 17C16.4714 17 15.9627 17.2107 15.5876 17.5858C15.2126 17.9609 15.0019 18.4696 15.0019 19C15.0019 19.5304 15.2126 20.0391 15.5876 20.4142C15.9627 20.7893 16.4714 21 17.0019 21ZM7.00586 21C7.53629 21 8.045 20.7893 8.42007 20.4142C8.79515 20.0391 9.00586 19.5304 9.00586 19C9.00586 18.4696 8.79515 17.9609 8.42007 17.5858C8.045 17.2107 7.53629 17 7.00586 17C6.47543 17 5.96672 17.2107 5.59165 17.5858C5.21657 17.9609 5.00586 18.4696 5.00586 19C5.00586 19.5304 5.21657 20.0391 5.59165 20.4142C5.96672 20.7893 6.47543 21 7.00586 21Z"
              stroke="#7E7E7E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.0038 12L6.00581 3M6.00581 3L8.00581 13M6.00581 3H3.83781C3.64781 3 3.48881 3.161 3.46581 3.375L3.13281 6.43C3.75281 6.43 4.25681 7.005 4.25681 7.715C4.25681 8.425 3.75381 9 3.13281 9C2.64281 9 2.16281 8.642 2.00781 8.143M18.9998 19C21.6828 19 21.9998 18.072 21.9998 15.512C21.9998 14.287 21.9998 13.675 21.7598 13.158C21.5098 12.618 21.0578 12.281 20.1078 11.593C19.1648 10.909 18.4938 10.141 17.8548 9.083C16.9428 7.573 16.4878 6.818 15.8048 6.409C15.1198 6 14.3138 6 12.7018 6H12.0018V13"
              stroke="#7E7E7E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.00695 18.9958C5.00695 18.9958 3.84695 19.0058 3.48695 18.9598C3.18695 18.8398 2.82295 18.5578 2.58695 18.4018C1.86695 17.9228 2.01195 18.1198 2.01195 17.6878L2.00795 14.0058V13.0458C2.00795 12.9858 1.94595 12.9988 2.40795 13.0058H21.48M9.00495 19.0018H15.003"
              stroke="#7E7E7E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "tally-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 5V19M10 5V19M14 5V19M18 5V19M3 17L21 7"
              stroke={color}
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "user-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.9287 19.6339H20.0667C20.2547 19.6368 20.4407 19.5942 20.6087 19.5096C20.7767 19.425 20.9218 19.3011 21.0314 19.1483C21.1411 18.9955 21.2121 18.8184 21.2385 18.6321C21.2648 18.4459 21.2457 18.2561 21.1827 18.0789C20.6375 16.912 19.7744 15.9224 18.6925 15.2238C17.6105 14.5251 16.3535 14.1456 15.0657 14.1289M15.0657 11.3699C15.5469 11.37 16.0235 11.2753 16.4681 11.0912C16.9128 10.9072 17.3168 10.6373 17.6572 10.297C17.9975 9.9568 18.2675 9.55284 18.4517 9.10823C18.6359 8.66363 18.7307 8.1871 18.7307 7.70585C18.732 7.22376 18.6382 6.74615 18.4545 6.3004C18.2709 5.85464 18.0012 5.4495 17.6607 5.10819C17.3202 4.76688 16.9158 4.49612 16.4704 4.31142C16.0251 4.12672 15.5478 4.03172 15.0657 4.03185M9.34067 11.4849C10.4424 11.4822 11.4981 11.0426 12.2761 10.2625C13.0541 9.48245 13.4909 8.4256 13.4907 7.32385C13.4907 6.22294 13.0533 5.16711 12.2749 4.38865C11.4964 3.61019 10.4406 3.17285 9.33967 3.17285C8.23876 3.17285 7.18294 3.61019 6.40447 4.38865C5.62601 5.16711 5.18867 6.22294 5.18867 7.32385C5.18867 8.42559 5.62572 9.48234 6.40392 10.2622C7.18213 11.0421 8.23793 11.4815 9.33967 11.4839M14.0257 20.8269C14.3779 20.8264 14.7231 20.7284 15.0231 20.5438C15.3231 20.3592 15.5661 20.0951 15.7253 19.7809C15.8844 19.4666 15.9534 19.1145 15.9247 18.7634C15.896 18.4123 15.7707 18.0761 15.5627 17.7919C14.8338 16.8243 13.8955 16.0342 12.818 15.4808C11.7404 14.9273 10.5517 14.6248 9.34067 14.5959C8.12959 14.6249 6.94077 14.9276 5.86325 15.4812C4.78573 16.0349 3.84745 16.8251 3.11867 17.7929C2.91133 18.0771 2.78657 18.4131 2.75818 18.7638C2.72979 19.1145 2.79886 19.4662 2.95778 19.7801C3.1167 20.094 3.35927 20.3579 3.65872 20.5426C3.95817 20.7273 4.30284 20.8257 4.65467 20.8269H14.0257Z"
              stroke={color}
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "settlement-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9542 11.1263C10.0312 11.1263 9.12898 10.8526 8.36155 10.3398C7.59412 9.82705 6.99599 9.09822 6.64278 8.24549C6.28957 7.39277 6.19715 6.45446 6.37722 5.54922C6.55728 4.64397 7.00174 3.81245 7.65438 3.15981C8.30703 2.50716 9.13855 2.0627 10.0438 1.88264C10.949 1.70258 11.8873 1.79499 12.7401 2.1482C13.5928 2.50141 14.3216 3.09955 14.8344 3.86698C15.3472 4.63441 15.6209 5.53666 15.6209 6.45964C15.6209 7.69731 15.1292 8.8843 14.254 9.75947C13.3789 10.6346 12.1919 11.1263 10.9542 11.1263ZM10.9542 3.17964C10.2949 3.17964 9.65048 3.37513 9.10231 3.74141C8.55415 4.10768 8.12691 4.62827 7.87462 5.23736C7.62232 5.84645 7.55631 6.51667 7.68493 7.16327C7.81355 7.80988 8.13102 8.40382 8.59719 8.86999C9.06337 9.33617 9.65731 9.65364 10.3039 9.78225C10.9505 9.91087 11.6207 9.84486 12.2298 9.59257C12.8389 9.34028 13.3595 8.91304 13.7258 8.36487C14.0921 7.81671 14.2875 7.17224 14.2875 6.51297C14.2875 6.07523 14.2013 5.64178 14.0338 5.23736C13.8663 4.83294 13.6208 4.46548 13.3112 4.15595C13.0017 3.84642 12.6342 3.60089 12.2298 3.43337C11.8254 3.26586 11.392 3.17964 10.9542 3.17964ZM14.6675 11.933C11.0599 11.1207 7.28544 11.5117 3.92088 13.0463C3.45815 13.2673 3.06772 13.6153 2.79508 14.0496C2.52244 14.484 2.3788 14.9868 2.38088 15.4996V19.4663C2.38088 19.5539 2.39813 19.6405 2.43163 19.7214C2.46513 19.8023 2.51424 19.8758 2.57614 19.9377C2.63805 19.9996 2.71154 20.0487 2.79243 20.0822C2.87331 20.1157 2.96 20.133 3.04755 20.133C3.1351 20.133 3.22179 20.1157 3.30267 20.0822C3.38355 20.0487 3.45705 19.9996 3.51895 19.9377C3.58086 19.8758 3.62996 19.8023 3.66347 19.7214C3.69697 19.6405 3.71422 19.5539 3.71422 19.4663V15.4996C3.70841 15.2401 3.77849 14.9845 3.91587 14.7643C4.05324 14.544 4.25193 14.3686 4.48755 14.2596C6.51433 13.3236 8.72174 12.8434 10.9542 12.853C12.2051 12.8515 13.4517 12.9992 14.6675 13.293V11.933ZM14.7609 18.273H18.8542V19.2063H14.7609V18.273Z"
              fill={color}
            />
            <path
              d="M22.1127 14.3137H18.666V15.647H21.446V21.227H11.9993V15.647H16.1993V15.927C16.1993 16.1038 16.2696 16.2734 16.3946 16.3984C16.5196 16.5234 16.6892 16.5937 16.866 16.5937C17.0428 16.5937 17.2124 16.5234 17.3374 16.3984C17.4624 16.2734 17.5327 16.1038 17.5327 15.927V13.3337C17.5327 13.1568 17.4624 12.9873 17.3374 12.8623C17.2124 12.7372 17.0428 12.667 16.866 12.667C16.6892 12.667 16.5196 12.7372 16.3946 12.8623C16.2696 12.9873 16.1993 13.1568 16.1993 13.3337V14.3137H11.3327C11.1559 14.3137 10.9863 14.3839 10.8613 14.5089C10.7363 14.6339 10.666 14.8035 10.666 14.9803V21.8937C10.666 22.0705 10.7363 22.24 10.8613 22.3651C10.9863 22.4901 11.1559 22.5603 11.3327 22.5603H22.1127C22.2895 22.5603 22.4591 22.4901 22.5841 22.3651C22.7091 22.24 22.7793 22.0705 22.7793 21.8937V14.9803C22.7793 14.8035 22.7091 14.6339 22.5841 14.5089C22.4591 14.3839 22.2895 14.3137 22.1127 14.3137Z"
              fill={color}
            />
          </svg>
        );
      case "report-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.75 3.75H18.6225V5.25H18.75C18.9489 5.25 19.1397 5.32902 19.2803 5.46967C19.421 5.61032 19.5 5.80109 19.5 6V21C19.5 21.1989 19.421 21.3897 19.2803 21.5303C19.1397 21.671 18.9489 21.75 18.75 21.75H5.25C5.05109 21.75 4.86032 21.671 4.71967 21.5303C4.57902 21.3897 4.5 21.1989 4.5 21V6C4.5 5.80109 4.57902 5.61032 4.71967 5.46967C4.86032 5.32902 5.05109 5.25 5.25 5.25H5.3775V3.75H5.25C4.65326 3.75 4.08097 3.98705 3.65901 4.40901C3.23705 4.83097 3 5.40326 3 6V21C3 21.5967 3.23705 22.169 3.65901 22.591C4.08097 23.0129 4.65326 23.25 5.25 23.25H18.75C19.3467 23.25 19.919 23.0129 20.341 22.591C20.7629 22.169 21 21.5967 21 21V6C21 5.40326 20.7629 4.83097 20.341 4.40901C19.919 3.98705 19.3467 3.75 18.75 3.75Z"
              fill={color}
            />
            <path
              d="M17.25 2.25H15V0H9V2.25H6.75V6.75H17.25V2.25ZM15.75 5.25H8.25V3.75H10.5V1.5H13.5V3.75H15.75V5.25Z"
              fill={color}
            />
            <path
              d="M7.5 9.75H16.5V11.25H7.5V9.75ZM7.5 13.5H16.5V15H7.5V13.5ZM7.5 17.25H16.5V18.75H7.5V17.25Z"
              fill={color}
            />
          </svg>
        );

      case "performance-icon":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 14.25C11.7775 14.25 11.56 14.184 11.375 14.0604C11.19 13.9368 11.0458 13.7611 10.9606 13.5555C10.8755 13.35 10.8532 13.1238 10.8966 12.9055C10.94 12.6873 11.0472 12.4868 11.2045 12.3295C11.3618 12.1722 11.5623 12.065 11.7805 12.0216C11.9988 11.9782 12.225 12.0005 12.4305 12.0856C12.6361 12.1708 12.8118 12.315 12.9354 12.5C13.059 12.685 13.125 12.9025 13.125 13.125C13.125 13.4234 13.0065 13.7095 12.7955 13.9205C12.5845 14.1315 12.2984 14.25 12 14.25ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM3.75 12V12.0309C6.05356 10.0742 8.97759 9 12 9C15.0224 9 17.9464 10.0742 20.25 12.0309V12C20.25 9.81196 19.3808 7.71354 17.8336 6.16637C16.2865 4.61919 14.188 3.75 12 3.75C9.81197 3.75 7.71355 4.61919 6.16637 6.16637C4.6192 7.71354 3.75 9.81196 3.75 12ZM10.0781 20.0231L8.47969 15.75H4.65282C5.19644 16.8107 5.96257 17.7415 6.89888 18.479C7.83519 19.2164 8.91962 19.7431 10.0781 20.0231ZM12 20.25H12.2334L14.115 15.2278C14.223 14.942 14.4153 14.6958 14.6665 14.5218C14.9176 14.3479 15.2157 14.2544 15.5213 14.2537H19.9388C19.9744 14.1309 20.0063 14.0062 20.0325 13.8787C18.9851 12.8101 17.735 11.9611 16.3554 11.3816C14.9758 10.802 13.4945 10.5035 11.9981 10.5035C10.5018 10.5035 9.02042 10.802 7.64085 11.3816C6.26127 11.9611 5.01118 12.8101 3.96375 13.8787C3.99282 14.0044 4.02469 14.1291 4.0575 14.2537H8.47969C8.78529 14.2546 9.08342 14.3483 9.33456 14.5224C9.5857 14.6965 9.77799 14.9429 9.88594 15.2288L11.7609 20.25H12ZM19.3472 15.75H15.5203L13.9181 20.0241C15.0774 19.7445 16.1627 19.2179 17.0997 18.4803C18.0367 17.7426 18.8033 16.8113 19.3472 15.75Z"
              fill="#7E7E7E"
            />
          </svg>
        );

      // case "Waiver":
      //   return (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <g filter="url(#filter0_i_1822_18021)">
      //         <rect
      //           width="24"
      //           height="24"
      //           rx="4"
      //           fill="url(#paint0_linear_1822_18021)"
      //         />
      //         <g clip-path="url(#clip0_1822_18021)">
      //           <path
      //             d="M20 16V17H14.9531L16.6016 18.6484L15.8984 19.3516L13.0469 16.5L15.8984 13.6484L16.6016 14.3516L14.9531 16H20ZM14.0938 12.6172L13.4062 13.3438C13.4062 13.3438 13.4062 13.4839 13.4062 13.5737C13.4062 13.6688 13.4062 13.8172 13.4062 13.8172V14.1336V14.5V15L12 16.5V17H5H4C4 16.3906 4.09115 15.7943 4.27344 15.2109C4.45573 14.6276 4.71875 14.0885 5.0625 13.5938C5.40625 13.099 5.8151 12.6589 6.28906 12.2734C6.76302 11.888 7.29167 11.5938 7.875 11.3906C7.58333 11.2031 7.32292 10.987 7.09375 10.7422C6.86458 10.4974 6.66667 10.2292 6.5 9.9375C6.33333 9.64583 6.21094 9.33854 6.13281 9.01562C6.05469 8.69271 6.01042 8.35417 6 8C6 7.44792 6.10417 6.92969 6.3125 6.44531C6.52083 5.96094 6.80469 5.53646 7.16406 5.17188C7.52344 4.80729 7.94792 4.52083 8.4375 4.3125C8.92708 4.10417 9.44792 4 10 4C10.5521 4 11.0703 4.10417 11.5547 4.3125C12.0391 4.52083 12.4635 4.80469 12.8281 5.16406C13.1927 5.52344 13.4792 5.94792 13.6875 6.4375C13.8958 6.92708 14 7.44792 14 8C14 8.71354 13.8359 9.35938 13.5078 9.9375C13.1797 10.5156 12.7188 11 12.125 11.3906C12.4896 11.526 12.8359 11.6979 13.1641 11.9062C13.4922 12.1146 13.8021 12.3516 14.0938 12.6172ZM7 8C7 8.41667 7.07812 8.80469 7.23438 9.16406C7.39062 9.52344 7.60417 9.84115 7.875 10.1172C8.14583 10.3932 8.46354 10.6094 8.82812 10.7656C9.19271 10.9219 9.58333 11 10 11C10.4115 11 10.7995 10.9219 11.1641 10.7656C11.5286 10.6094 11.8464 10.3958 12.1172 10.125C12.388 9.85417 12.6042 9.53646 12.7656 9.17188C12.9271 8.80729 13.0052 8.41667 13 8C13 7.58854 12.9219 7.20052 12.7656 6.83594C12.6094 6.47135 12.3958 6.15365 12.125 5.88281C11.8542 5.61198 11.5339 5.39583 11.1641 5.23438C10.7943 5.07292 10.4062 4.99479 10 5C9.58333 5 9.19531 5.07812 8.83594 5.23438C8.47656 5.39062 8.15885 5.60417 7.88281 5.875C7.60677 6.14583 7.39062 6.46615 7.23438 6.83594C7.07812 7.20573 7 7.59375 7 8Z"
      //             fill="white"
      //           />
      //         </g>
      //       </g>
      //       <defs>
      //         <filter
      //           id="filter0_i_1822_18021"
      //           x="-1"
      //           y="-1"
      //           width="25"
      //           height="25"
      //           filterUnits="userSpaceOnUse"
      //           color-interpolation-filters="sRGB"
      //         >
      //           <feFlood flood-opacity="0" result="BackgroundImageFix" />
      //           <feBlend
      //             mode="normal"
      //             in="SourceGraphic"
      //             in2="BackgroundImageFix"
      //             result="shape"
      //           />
      //           <feColorMatrix
      //             in="SourceAlpha"
      //             type="matrix"
      //             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      //             result="hardAlpha"
      //           />
      //           <feOffset dx="-1" dy="-1" />
      //           <feGaussianBlur stdDeviation="1.5" />
      //           <feComposite
      //             in2="hardAlpha"
      //             operator="arithmetic"
      //             k2="-1"
      //             k3="1"
      //           />
      //           <feColorMatrix
      //             type="matrix"
      //             values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
      //           />
      //           <feBlend
      //             mode="normal"
      //             in2="shape"
      //             result="effect1_innerShadow_1822_18021"
      //           />
      //         </filter>
      //         <linearGradient
      //           id="paint0_linear_1822_18021"
      //           x1="0.330274"
      //           y1="6.12959e-07"
      //           x2="23.6697"
      //           y2="24"
      //           gradientUnits="userSpaceOnUse"
      //         >
      //           <stop stop-color="#868CFF" />
      //           <stop offset="1" stop-color="#4318FF" />
      //         </linearGradient>
      //         <clipPath id="clip0_1822_18021">
      //           <rect
      //             width="16"
      //             height="16"
      //             fill="white"
      //             transform="translate(4 4)"
      //           />
      //         </clipPath>
      //       </defs>
      //     </svg>
      //   );
      case "Waiver":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18029)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18029)" />
              <path
                opacity="0.5"
                d="M5 10.3337C5 7.19116 5 5.61949 5.97667 4.64366C6.95333 3.66783 8.52417 3.66699 11.6667 3.66699H13.3333C16.4758 3.66699 18.0475 3.66699 19.0233 4.64366C19.9992 5.62033 20 7.19116 20 10.3337V13.667C20 16.8095 20 18.3812 19.0233 19.357C18.0467 20.3328 16.4758 20.3337 13.3333 20.3337H11.6667C8.52417 20.3337 6.9525 20.3337 5.97667 19.357C5.00083 18.3803 5 16.8095 5 13.667V10.3337Z"
                fill="white"
              />
              <path
                d="M16.2663 15.7513C16.4122 15.6379 16.5447 15.5054 16.8088 15.2413L20.1063 11.9429C20.1863 11.8638 20.1497 11.7263 20.0438 11.6888C19.5274 11.5098 19.0588 11.215 18.6738 10.8271C18.2859 10.4421 17.9912 9.97349 17.8122 9.45709C17.7747 9.35125 17.6372 9.31459 17.558 9.39459L14.2588 12.6921C13.9947 12.9563 13.8622 13.0888 13.7488 13.2346C13.6138 13.4074 13.4994 13.5924 13.4055 13.7896C13.3263 13.9563 13.2672 14.1346 13.1488 14.4896L12.9955 14.9479L12.7522 15.6771L12.5247 16.3604C12.4963 16.4461 12.4923 16.5379 12.5131 16.6257C12.5339 16.7135 12.5787 16.7938 12.6425 16.8576C12.7063 16.9214 12.7866 16.9662 12.8744 16.987C12.9622 17.0078 13.054 17.0038 13.1397 16.9754L13.823 16.7479L14.5522 16.5046L15.0105 16.3513C15.3655 16.2329 15.5438 16.1746 15.7105 16.0946C15.9077 16.0001 16.0936 15.8857 16.2663 15.7513ZM21.1397 10.9104C21.4777 10.5723 21.6676 10.1137 21.6675 9.63554C21.6674 9.1574 21.4774 8.69888 21.1393 8.36084C20.8011 8.0228 20.3425 7.83293 19.8644 7.83301C19.3862 7.83309 18.9277 8.0231 18.5897 8.36125L18.4847 8.46792C18.434 8.51749 18.3962 8.57874 18.3747 8.6463C18.3532 8.71386 18.3486 8.78567 18.3613 8.85542C18.378 8.94459 18.4072 9.07625 18.4613 9.23209C18.5697 9.54459 18.7747 9.95459 19.1605 10.3404C19.5463 10.7263 19.9563 10.9313 20.2688 11.0396C20.4255 11.0938 20.5563 11.1229 20.6455 11.1396C20.7153 11.1516 20.7869 11.1466 20.8543 11.1252C20.9217 11.1037 20.983 11.0664 21.033 11.0163L21.1397 10.9104Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.54102 9.5C8.54102 9.33424 8.60686 9.17527 8.72407 9.05806C8.84128 8.94085 9.00026 8.875 9.16602 8.875H14.5827C14.7484 8.875 14.9074 8.94085 15.0246 9.05806C15.1418 9.17527 15.2077 9.33424 15.2077 9.5C15.2077 9.66576 15.1418 9.82473 15.0246 9.94194C14.9074 10.0592 14.7484 10.125 14.5827 10.125H9.16602C9.00026 10.125 8.84128 10.0592 8.72407 9.94194C8.60686 9.82473 8.54102 9.66576 8.54102 9.5ZM8.54102 12.8333C8.54102 12.6676 8.60686 12.5086 8.72407 12.3914C8.84128 12.2742 9.00026 12.2083 9.16602 12.2083H11.666C11.8318 12.2083 11.9907 12.2742 12.108 12.3914C12.2252 12.5086 12.291 12.6676 12.291 12.8333C12.291 12.9991 12.2252 13.1581 12.108 13.2753C11.9907 13.3925 11.8318 13.4583 11.666 13.4583H9.16602C9.00026 13.4583 8.84128 13.3925 8.72407 13.2753C8.60686 13.1581 8.54102 12.9991 8.54102 12.8333ZM8.54102 16.1667C8.54102 16.0009 8.60686 15.8419 8.72407 15.7247C8.84128 15.6075 9.00026 15.5417 9.16602 15.5417H10.416C10.5818 15.5417 10.7407 15.6075 10.858 15.7247C10.9752 15.8419 11.041 16.0009 11.041 16.1667C11.041 16.3324 10.9752 16.4914 10.858 16.6086C10.7407 16.7258 10.5818 16.7917 10.416 16.7917H9.16602C9.00026 16.7917 8.84128 16.7258 8.72407 16.6086C8.60686 16.4914 8.54102 16.3324 8.54102 16.1667Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18029"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18029" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18029"
                x1="0.830274"
                y1="6.12959e-07"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );

      case "Recovery":
        return (
          <svg
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18047)">
              <rect
                x="0.833984"
                width="24"
                height="24"
                rx="4"
                fill="url(#paint0_linear_1822_18047)"
              />
              <path
                d="M13.334 18C13.334 14.69 16.024 12 19.334 12C20.424 12 21.454 12.3 22.334 12.81V12L20.254 6C20.054 5.42 19.494 5 18.834 5H7.83398C7.17398 5 6.61398 5.42 6.41398 6L4.33398 12V20C4.33398 20.55 4.78398 21 5.33398 21H6.33398C6.88398 21 7.33398 20.55 7.33398 20V19H13.424C13.374 18.67 13.334 18.34 13.334 18ZM7.83398 6.5H18.834L20.334 11H6.33398L7.83398 6.5ZM7.83398 16C7.00398 16 6.33398 15.33 6.33398 14.5C6.33398 13.67 7.00398 13 7.83398 13C8.66398 13 9.33398 13.67 9.33398 14.5C9.33398 15.33 8.66398 16 7.83398 16ZM19.334 15V17H23.334V19H19.334V21L16.334 18L19.334 15Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18047"
                x="-0.166016"
                y="-1"
                width="25.5"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18047" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18047"
                x1="1.16426"
                y1="6.12959e-07"
                x2="24.5037"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "Car Drop":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18056)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18056)" />
              <path
                d="M11.5312 17.1875C11.5312 14.0844 14.0531 11.5625 17.1562 11.5625C18.1781 11.5625 19.1437 11.8438 19.9688 12.3219V11.5625L18.0188 5.9375C17.8313 5.39375 17.3062 5 16.6875 5H6.375C5.75625 5 5.23125 5.39375 5.04375 5.9375L3.09375 11.5625V19.0625C3.09375 19.5781 3.51562 20 4.03125 20H4.96875C5.48438 20 5.90625 19.5781 5.90625 19.0625V18.125H11.6156C11.5688 17.8156 11.5312 17.5063 11.5312 17.1875ZM6.375 6.40625H16.6875L18.0938 10.625H4.96875L6.375 6.40625ZM6.375 15.3125C5.59687 15.3125 4.96875 14.6844 4.96875 13.9062C4.96875 13.1281 5.59687 12.5 6.375 12.5C7.15312 12.5 7.78125 13.1281 7.78125 13.9062C7.78125 14.6844 7.15312 15.3125 6.375 15.3125ZM18.0938 20V18.125H14.3438V16.25H18.0938V14.375L20.9062 17.1875L18.0938 20Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18056"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18056" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18056"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "Car Change":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18064)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18064)" />
              <path
                d="M13.4375 2.9375C13.4375 2.41797 13.0195 2 12.5 2C11.9805 2 11.5625 2.41797 11.5625 2.9375V6.0625C11.5625 6.58203 11.9805 7 12.5 7C13.0195 7 13.4375 6.58203 13.4375 6.0625V2.9375ZM9.75781 10.75H15.2383C15.5039 10.75 15.7383 10.918 15.8281 11.1641L16.5742 13.25H8.42578L9.17188 11.1641C9.26172 10.9141 9.49609 10.75 9.76172 10.75H9.75781ZM6.81641 10.3242L5.71094 13.4219C4.92578 13.7539 4.375 14.5312 4.375 15.4375V20.75C4.375 21.4414 4.93359 22 5.625 22H6.25C6.94141 22 7.5 21.4414 7.5 20.75V19.5H17.5V20.75C17.5 21.4414 18.0586 22 18.75 22H19.375C20.0664 22 20.625 21.4414 20.625 20.75V15.4375C20.625 14.5312 20.0742 13.7539 19.2891 13.4219L18.1836 10.3242C17.7383 9.08203 16.5625 8.25 15.2422 8.25H9.76172C8.44141 8.25 7.26172 9.08203 6.82031 10.3242H6.81641ZM7.5 15.4375C7.74864 15.4375 7.9871 15.5363 8.16291 15.7121C8.33873 15.8879 8.4375 16.1264 8.4375 16.375C8.4375 16.6236 8.33873 16.8621 8.16291 17.0379C7.9871 17.2137 7.74864 17.3125 7.5 17.3125C7.25136 17.3125 7.0129 17.2137 6.83709 17.0379C6.66127 16.8621 6.5625 16.6236 6.5625 16.375C6.5625 16.1264 6.66127 15.8879 6.83709 15.7121C7.0129 15.5363 7.25136 15.4375 7.5 15.4375ZM16.5625 16.375C16.5625 16.1264 16.6613 15.8879 16.8371 15.7121C17.0129 15.5363 17.2514 15.4375 17.5 15.4375C17.7486 15.4375 17.9871 15.5363 18.1629 15.7121C18.3387 15.8879 18.4375 16.1264 18.4375 16.375C18.4375 16.6236 18.3387 16.8621 18.1629 17.0379C17.9871 17.2137 17.7486 17.3125 17.5 17.3125C17.2514 17.3125 17.0129 17.2137 16.8371 17.0379C16.6613 16.8621 16.5625 16.6236 16.5625 16.375ZM4.02344 3.52344C3.65625 3.89062 3.65625 4.48438 4.02344 4.84766L5.89844 6.72266C6.26562 7.08984 6.85938 7.08984 7.22266 6.72266C7.58594 6.35547 7.58984 5.76172 7.22266 5.39844L5.35156 3.52344C4.98438 3.15625 4.39062 3.15625 4.02734 3.52344H4.02344ZM19.6484 3.52344L17.7734 5.39844C17.4062 5.76562 17.4062 6.35938 17.7734 6.72266C18.1406 7.08594 18.7344 7.08984 19.0977 6.72266L20.9727 4.84766C21.3398 4.48047 21.3398 3.88672 20.9727 3.52344C20.6055 3.16016 20.0117 3.15625 19.6484 3.52344Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18064"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18064" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18064"
                x1="0.830274"
                y1="6.12959e-07"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "Scheme":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18072)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18072)" />
              <path
                d="M5.74935 12.8337V7.87116M11.166 5.75033H16.166M18.2493 11.167V16.167M14.916 14.917L14.0827 14.0837M16.166 5.33366C16.166 4.54783 16.166 4.15533 16.4102 3.91116C16.6543 3.66699 17.0468 3.66699 17.8327 3.66699H18.666C19.4518 3.66699 19.8443 3.66699 20.0885 3.91116C20.3327 4.15533 20.3327 4.54783 20.3327 5.33366V6.16699C20.3327 6.95283 20.3327 7.34533 20.0885 7.58949C19.8443 7.83366 19.4518 7.83366 18.666 7.83366H17.8327C17.0468 7.83366 16.6543 7.83366 16.4102 7.58949C16.166 7.34533 16.166 6.95283 16.166 6.16699V5.33366ZM9.91602 11.5837C9.91602 10.7978 9.91602 10.4053 10.1602 10.1612C10.4043 9.91699 10.7968 9.91699 11.5827 9.91699H12.416C13.2018 9.91699 13.5943 9.91699 13.8385 10.1612C14.0827 10.4053 14.0827 10.7978 14.0827 11.5837V12.417C14.0827 13.2028 14.0827 13.5953 13.8385 13.8395C13.5943 14.0837 13.2018 14.0837 12.416 14.0837H11.5827C10.7968 14.0837 10.4043 14.0837 10.1602 13.8395C9.91602 13.5953 9.91602 13.2028 9.91602 12.417V11.5837ZM16.166 17.8337C16.166 17.0478 16.166 16.6553 16.4102 16.4112C16.6543 16.167 17.0468 16.167 17.8327 16.167H18.666C19.4518 16.167 19.8443 16.167 20.0885 16.4112C20.3327 16.6553 20.3327 17.0478 20.3327 17.8337V18.667C20.3327 19.4528 20.3327 19.8453 20.0885 20.0895C19.8443 20.3337 19.4518 20.3337 18.666 20.3337H17.8327C17.0468 20.3337 16.6543 20.3337 16.4102 20.0895C16.166 19.8453 16.166 19.4528 16.166 18.667V17.8337ZM3.66602 17.8337C3.66602 17.0478 3.66602 16.6553 3.91018 16.4112C4.15435 16.167 4.54685 16.167 5.33268 16.167H6.16602C6.95185 16.167 7.34435 16.167 7.58852 16.4112C7.83268 16.6553 7.83268 17.0478 7.83268 17.8337V18.667C7.83268 19.4528 7.83268 19.8453 7.58852 20.0895C7.34435 20.3337 6.95185 20.3337 6.16602 20.3337H5.33268C4.54685 20.3337 4.15435 20.3337 3.91018 20.0895C3.66602 19.8453 3.66602 19.4528 3.66602 18.667V17.8337ZM3.66602 5.33366C3.66602 4.54783 3.66602 4.15533 3.91018 3.91116C4.15435 3.66699 4.54685 3.66699 5.33268 3.66699H6.16602C6.95185 3.66699 7.34435 3.66699 7.58852 3.91116C7.83268 4.15533 7.83268 4.54783 7.83268 5.33366V6.16699C7.83268 6.95283 7.83268 7.34533 7.58852 7.58949C7.34435 7.83366 6.95185 7.83366 6.16602 7.83366H5.33268C4.54685 7.83366 4.15435 7.83366 3.91018 7.58949C3.66602 7.34533 3.66602 6.95283 3.66602 6.16699V5.33366Z"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18072"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18072" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18072"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "Drop End":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18080)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18080)" />
              <path
                d="M16.875 3.875C16.875 3.54348 17.0067 3.22554 17.2411 2.99112C17.4755 2.7567 17.7935 2.625 18.125 2.625H20.625C20.9565 2.625 21.2745 2.7567 21.5089 2.99112C21.7433 3.22554 21.875 3.54348 21.875 3.875V7.625C21.875 7.95652 21.7433 8.27446 21.5089 8.50888C21.2745 8.7433 20.9565 8.875 20.625 8.875H20V20.75C20 20.9158 19.9342 21.0747 19.8169 21.1919C19.6997 21.3092 19.5408 21.375 19.375 21.375C19.2092 21.375 19.0503 21.3092 18.9331 21.1919C18.8158 21.0747 18.75 20.9158 18.75 20.75V8.875H18.125C17.7935 8.875 17.4755 8.7433 17.2411 8.50888C17.0067 8.27446 16.875 7.95652 16.875 7.625V3.875ZM15.9375 3.875H9.00437C8.43556 3.87496 7.88373 4.06889 7.44001 4.42478C6.99628 4.78067 6.68718 5.27724 6.56375 5.8325L6.165 7.625H5.625C5.45924 7.625 5.30027 7.69085 5.18306 7.80806C5.06585 7.92527 5 8.08424 5 8.25C5 8.41576 5.06585 8.57473 5.18306 8.69194C5.30027 8.80915 5.45924 8.875 5.625 8.875H5.8875L5.68125 9.80312C5.28602 10.0179 4.95606 10.3354 4.72616 10.722C4.49626 11.1087 4.37495 11.5502 4.375 12V18.25C4.375 18.7473 4.57254 19.2242 4.92417 19.5758C5.27581 19.9275 5.75272 20.125 6.25 20.125H6.875C7.37228 20.125 7.84919 19.9275 8.20083 19.5758C8.55246 19.2242 8.75 18.7473 8.75 18.25V17.625H16.25V18.25C16.2499 18.6932 16.4067 19.1221 16.6928 19.4607C16.9788 19.7992 17.3755 20.0255 17.8125 20.0994V18.7913C17.7175 18.7364 17.6386 18.6575 17.5837 18.5625C17.5289 18.4675 17.5 18.3597 17.5 18.25V17.625H17.8125V9.79063C17.5242 9.74898 17.2471 9.65017 16.9975 9.5H7.02875L7.78375 6.10375C7.84546 5.82617 7.99996 5.57793 8.22176 5.39999C8.44356 5.22205 8.7194 5.12505 9.00375 5.125H15.9375V3.875ZM5.625 18.25V17.625H7.5V18.25C7.5 18.4158 7.43415 18.5747 7.31694 18.6919C7.19973 18.8092 7.04076 18.875 6.875 18.875H6.25C6.08424 18.875 5.92527 18.8092 5.80806 18.6919C5.69085 18.5747 5.625 18.4158 5.625 18.25ZM10.9375 15.125C10.7717 15.125 10.6128 15.0592 10.4956 14.9419C10.3783 14.8247 10.3125 14.6658 10.3125 14.5C10.3125 14.3342 10.3783 14.1753 10.4956 14.0581C10.6128 13.9408 10.7717 13.875 10.9375 13.875H14.0625C14.2283 13.875 14.3872 13.9408 14.5044 14.0581C14.6217 14.1753 14.6875 14.3342 14.6875 14.5C14.6875 14.6658 14.6217 14.8247 14.5044 14.9419C14.3872 15.0592 14.2283 15.125 14.0625 15.125H10.9375ZM9.375 12.9375C9.375 13.1861 9.27623 13.4246 9.10041 13.6004C8.9246 13.7762 8.68614 13.875 8.4375 13.875C8.18886 13.875 7.9504 13.7762 7.77459 13.6004C7.59877 13.4246 7.5 13.1861 7.5 12.9375C7.5 12.6889 7.59877 12.4504 7.77459 12.2746C7.9504 12.0988 8.18886 12 8.4375 12C8.68614 12 8.9246 12.0988 9.10041 12.2746C9.27623 12.4504 9.375 12.6889 9.375 12.9375ZM16.5625 12C16.8111 12 17.0496 12.0988 17.2254 12.2746C17.4012 12.4504 17.5 12.6889 17.5 12.9375C17.5 13.1861 17.4012 13.4246 17.2254 13.6004C17.0496 13.7762 16.8111 13.875 16.5625 13.875C16.3139 13.875 16.0754 13.7762 15.8996 13.6004C15.7238 13.4246 15.625 13.1861 15.625 12.9375C15.625 12.6889 15.7238 12.4504 15.8996 12.2746C16.0754 12.0988 16.3139 12 16.5625 12Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18080"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18080" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18080"
                x1="0.830274"
                y1="6.12959e-07"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "hub_transfer":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="childHubGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
              <filter
                id="innerShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                0 0 0 0 1
                0 0 0 0 1
                0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>
            <g filter="url(#innerShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#childHubGradient)" />
              <g transform="translate(-5.8, -5.0) scale(1.48)">
                <path
                  d="M7 10.5C7 9.39543 7.89543 8.5 9 8.5C10.1046 8.5 11 9.39543 11 10.5C11 11.6046 10.1046 12.5 9 12.5C7.89543 12.5 7 11.6046 7 10.5Z
                   M6 15C6 13.3431 7.34315 12 9 12C10.6569 12 12 13.3431 12 15V15.5H6V15Z
                   M16.5 8L20 11L16.5 14V12.5H12V9.5H16.5V8Z"
                  fill="white"
                />
              </g>
            </g>
          </svg>
        );
      case "driver-return":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="bgGradient"
                x1="0"
                y1="0"
                x2="24"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
            <rect x="0.5" width="24" height="24" rx="4" fill="url(#bgGradient)" />
            <g filter="url(#innerShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#childHubGradient)" />
              <g transform="translate(-4.9, -5.3) scale(1.5)" fill="white">
                <circle cx="12.5" cy="8" r="2" />
                <path d="M10 14C10 12.9 10.9 12 12 12H13C14.1 12 15 12.9 15 14V17H10V14Z" />
                <path d="M7 12L9.5 9.5L8.79 8.79L5.79 11.79C5.6 11.98 5.5 12.23 5.5 12.5C5.5 12.77 5.6 13.02 5.79 13.21L8.79 16.21L9.5 15.5L7 13H17V12H7Z" />
              </g>
            </g>
          </svg>
        );
      case "add-cars":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="bgGradient"
                x1="0"
                y1="0"
                x2="24"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>

            <rect x="0.5" width="24" height="24" rx="4" fill="url(#bgGradient)" />

            <g transform="translate(-4.5, -6.5) scale(1.6)" fill="white">
              <path d="M5 11L5.94 8.33C6.1 7.89 6.52 7.6 6.98 7.6H11.02C11.48 7.6 11.9 7.89 12.06 8.33L13 11V14C13 14.55 12.55 15 12 15C11.45 15 11 14.55 11 14H7C7 14.55 6.55 15 6 15C5.45 15 5 14.55 5 14V11ZM6.5 9C6.22 9 6 9.22 6 9.5V10H12V9.5C12 9.22 11.78 9 11.5 9H6.5Z" />

              <path d="M14 8H15.5V9.5H17V10.5H15.5V12H14.5V10.5H13V9.5H14.5V8Z" />
            </g>
          </svg>
        );
      case "previous-btn":
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 15L7.5 10L12.5 5"
              // stroke="#D3D3D3"
              stroke="#4318FF"
              // stroke ={color}
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "next-btn":
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 15L12.5 10L7.5 5"
              stroke="#4318FF"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "dropdown-icon":
        return (
          <div>
            <svg
              className="pointer-events-none absolute right-[10px] top-1/2 transform -translate-y-1/2 text-gray-500"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 011.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        );
      case "upload-image":
        return (
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "4px",
              background: "linear-gradient(135deg, #868CFF 0%, #4318FF 100%)",
              boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M17 7H15.586L14.293 5.707C14.1055 5.51947 13.8512 5.41406 13.586 5.41406H10.414C10.1488 5.41406 9.89453 5.51947 9.70703 5.70703L8.41406 7H7C5.89543 7 5 7.89543 5 9V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V9C19 7.89543 18.1046 7 17 7ZM12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16ZM12 11.5C11.1716 11.5 10.5 12.1716 10.5 13C10.5 13.8284 11.1716 14.5 12 14.5C12.8284 14.5 13.5 13.8284 13.5 13C13.5 12.1716 12.8284 11.5 12 11.5Z" />
            </svg>
          </div>
        );
      case "send-agreement":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="cameraGradient-sendAgreement"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="innerShadow-sendAgreement"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                            0 0 0 0 1
                            0 0 0 0 1
                            0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>

            <g filter="url(#innerShadow-sendAgreement)">
              <rect
                x="0.5"
                width="24"
                height="24"
                rx="4"
                fill="url(#cameraGradient-sendAgreement)"
              />

              <g transform="translate(5.5, 6)">
                <rect x="0" y="3" width="13" height="9" rx="2" stroke="white" strokeWidth="1.5" />
                <rect x="3" y="0" width="3.5" height="2" rx="0.5" fill="white" />
                <circle cx="6.5" cy="7.5" r="2.2" fill="white" />
              </g>
            </g>
          </svg>
        );

      case "agreement-history":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="agreementHistoryGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="innerShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                0 0 0 0 1
                0 0 0 0 1
                0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>

            <g filter="url(#innerShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#agreementHistoryGradient)" />

              <g transform="translate(3.0, 3.0) scale(1.5)">
                <rect
                  x="0.5"
                  y="0.5"
                  width="8"
                  height="10"
                  rx="1"
                  stroke="white"
                  strokeWidth="1.2"
                  fill="none"
                />
                <line x1="2" y1="3" x2="6.5" y2="3" stroke="white" strokeWidth="1" />
                <line x1="2" y1="5" x2="6.5" y2="5" stroke="white" strokeWidth="1" />
              </g>

              <g transform="translate(11.0, 10.0) scale(1.5)">
                <circle cx="4" cy="4" r="3.5" stroke="white" strokeWidth="1" fill="none" />
                <line x1="4" y1="2" x2="4" y2="4" stroke="white" strokeWidth="1" />
                <line x1="4" y1="4" x2="5.5" y2="5" stroke="white" strokeWidth="1" />
              </g>
            </g>
          </svg>
        );
      case "assign-to-hm":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18577)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18577)" />
              <path
                d="M12 16.0003L8.66667 12.667H10.6667V10.0003H13.3333V12.667H15.3333M12 6.00033C12.1768 6.00033 12.3464 6.07056 12.4714 6.19559C12.5964 6.32061 12.6667 6.49018 12.6667 6.66699C12.6667 6.8438 12.5964 7.01337 12.4714 7.1384C12.3464 7.26342 12.1768 7.33366 12 7.33366C11.8232 7.33366 11.6536 7.26342 11.5286 7.1384C11.4036 7.01337 11.3333 6.8438 11.3333 6.66699C11.3333 6.49018 11.4036 6.32061 11.5286 6.19559C11.6536 6.07056 11.8232 6.00033 12 6.00033ZM16.6667 6.00033H13.88C13.6 5.22699 12.8667 4.66699 12 4.66699C11.1333 4.66699 10.4 5.22699 10.12 6.00033H7.33333C6.97971 6.00033 6.64057 6.1408 6.39052 6.39085C6.14048 6.6409 6 6.98004 6 7.33366V16.667C6 17.0206 6.14048 17.3598 6.39052 17.6098C6.64057 17.8598 6.97971 18.0003 7.33333 18.0003H16.6667C17.0203 18.0003 17.3594 17.8598 17.6095 17.6098C17.8595 17.3598 18 17.0206 18 16.667V7.33366C18 6.98004 17.8595 6.6409 17.6095 6.39085C17.3594 6.1408 17.0203 6.00033 16.6667 6.00033Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18577"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18577" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18577"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "location":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18793)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18793)" />
              <g clip-path="url(#clip0_1822_18793)">
                <path
                  d="M17.6455 6.59926C18.5545 8.55526 18.3482 10.8578 17.3417 12.729C16.516 14.2643 15.2837 15.534 14.2682 16.9395C13.804 17.583 13.3352 18.252 13.0165 18.9848C12.9107 19.2285 12.8192 19.4783 12.7292 19.7288C12.6385 19.9785 12.5612 20.2335 12.4742 20.4848C12.3925 20.7203 12.2972 20.9978 12.004 21H11.9987C11.6492 20.9993 11.5645 20.6025 11.4775 20.3348C11.2645 19.6793 11.0417 19.05 10.7132 18.441C10.3307 17.733 9.85446 17.0783 9.37071 16.4378L17.6455 6.59926ZM9.40896 8.77877L6.43971 12.309C6.98271 13.464 7.80546 14.4563 8.59296 15.444C8.77846 15.6765 8.96271 15.9105 9.14571 16.146L12.8837 11.7023L12.862 11.7098C11.5562 12.1605 10.0937 11.4915 9.56796 10.2195C9.49617 10.0468 9.44361 9.86672 9.41121 9.68252C9.36396 9.35477 9.35346 9.11177 9.40821 8.78402L9.40896 8.77877ZM7.11921 5.36176L7.11696 5.36476C5.65671 7.21426 5.40621 9.77477 6.27921 11.9423L9.86796 7.67552L9.82446 7.63802L7.11921 5.36176ZM13.996 3.32701L11.1175 6.74926L11.1377 6.74176C12.3377 6.32851 13.69 6.85426 14.3027 7.96127C14.4347 8.20051 14.545 8.47352 14.5855 8.74502C14.6365 9.07951 14.6492 9.32477 14.5945 9.66002L14.5922 9.67202L17.4692 6.25126C16.7175 4.87991 15.4815 3.83806 14.0027 3.32926L13.996 3.32701ZM10.0997 7.40101L13.6217 3.21376L13.5865 3.20476C13.0653 3.06769 12.5286 2.99886 11.9897 3.00001C11.1172 3.00823 10.2557 3.19676 9.45954 3.55375C8.66333 3.91075 7.94953 4.42851 7.36296 5.07451L7.35096 5.08801L10.0997 7.40101Z"
                  fill="white"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18793"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18793" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18793"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
              <clipPath id="clip0_1822_18793">
                <rect width="18" height="18" fill="white" transform="translate(3 3)" />
              </clipPath>
            </defs>
          </svg>
        );
      case "trip-activity-report":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1842_24007)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1842_24007)" />
              <mask
                id="mask0_1842_24007"
                maskUnits="userSpaceOnUse"
                x="5"
                y="4"
                width="14"
                height="16"
              >
                <path
                  d="M5.66602 6.33301C5.66602 6.06779 5.77137 5.81344 5.95891 5.6259C6.14645 5.43836 6.4008 5.33301 6.66602 5.33301H14.666C14.9312 5.33301 15.1856 5.43836 15.3731 5.6259C15.5607 5.81344 15.666 6.06779 15.666 6.33301V18.6663H6.66602C6.4008 18.6663 6.14645 18.561 5.95891 18.3734C5.77137 18.1859 5.66602 17.9316 5.66602 17.6663V6.33301Z"
                  fill="white"
                  stroke="white"
                  stroke-width="1.33333"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.666 11.9997C15.666 11.8229 15.7363 11.6533 15.8613 11.5283C15.9863 11.4032 16.1559 11.333 16.3327 11.333H17.666C17.8428 11.333 18.0124 11.4032 18.1374 11.5283C18.2624 11.6533 18.3327 11.8229 18.3327 11.9997V17.6663C18.3327 17.9316 18.2273 18.1859 18.0398 18.3734C17.8523 18.561 17.5979 18.6663 17.3327 18.6663H15.666V11.9997Z"
                  stroke="white"
                  stroke-width="1.33333"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.66602 7.99951H10.3327M7.66602 10.3328H11.666"
                  stroke="black"
                  stroke-width="1.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </mask>
              <g mask="url(#mask0_1842_24007)">
                <path d="M4 4H20V20H4V4Z" fill="white" />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_i_1842_24007"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1842_24007" />
              </filter>
              <linearGradient
                id="paint0_linear_1842_24007"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "send-request":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1996_10345)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1996_10345)" />
              <path
                d="M6.616 21C6.15533 21 5.771 20.846 5.463 20.538C5.155 20.23 5.00067 19.8457 5 19.385V4.615C5 4.155 5.15433 3.771 5.463 3.463C5.77167 3.155 6.156 3.00067 6.616 3H14.731L19 7.27V19.385C19 19.845 18.846 20.2293 18.538 20.538C18.23 20.8467 17.8453 21.0007 17.384 21H6.616ZM6.616 20H17.385C17.5383 20 17.6793 19.936 17.808 19.808C17.9367 19.68 18.0007 19.5387 18 19.384V7.77H15.038C14.8093 7.77 14.6177 7.69267 14.463 7.538C14.3083 7.38333 14.231 7.19167 14.231 6.963V4H6.616C6.462 4 6.32067 4.064 6.192 4.192C6.06333 4.32 5.99933 4.461 6 4.615V19.385C6 19.5383 6.064 19.6793 6.192 19.808C6.32 19.9367 6.461 20.0007 6.615 20"
                fill="white"
              />
              <path
                d="M6.616 20H17.385C17.5383 20 17.6793 19.936 17.808 19.808C17.9367 19.68 18.0007 19.5387 18 19.384V7.77H15.038C14.8093 7.77 14.6177 7.69267 14.463 7.538C14.3083 7.38333 14.231 7.19167 14.231 6.963V4H6.616C6.462 4 6.32067 4.064 6.192 4.192C6.06333 4.32 5.99933 4.461 6 4.615V19.385C6 19.5383 6.064 19.6793 6.192 19.808C6.32 19.9367 6.461 20.0007 6.615 20M6 7.77V4V20M6.616 21C6.15533 21 5.771 20.846 5.463 20.538C5.155 20.23 5.00067 19.8457 5 19.385V4.615C5 4.155 5.15433 3.771 5.463 3.463C5.77167 3.155 6.156 3.00067 6.616 3H14.731L19 7.27V19.385C19 19.845 18.846 20.2293 18.538 20.538C18.23 20.8467 17.8453 21.0007 17.384 21H6.616Z"
                stroke="white"
                stroke-width="0.5"
              />
              <path
                d="M11.576 18.144C10.776 18.144 10.172 17.924 9.764 17.484C9.364 17.036 9.164 16.416 9.164 15.624V13.896C9.932 13.896 10.544 13.872 11 13.824C11.464 13.768 11.808 13.664 12.032 13.512C12.264 13.352 12.416 13.116 12.488 12.804C12.56 12.492 12.596 12.076 12.596 11.556V10.032H13.544V11.556C13.544 12.132 13.488 12.616 13.376 13.008C13.272 13.4 13.088 13.716 12.824 13.956C12.568 14.188 12.216 14.356 11.768 14.46C11.328 14.556 10.776 14.604 10.112 14.604V15.66C10.112 16.172 10.224 16.584 10.448 16.896C10.672 17.2 11.052 17.352 11.588 17.352C12.084 17.352 12.444 17.208 12.668 16.92C12.9 16.632 13.016 16.236 13.016 15.732H13.952C13.944 16.524 13.732 17.124 13.316 17.532C12.908 17.94 12.328 18.144 11.576 18.144ZM8.636 12.432V11.712H15.14V12.432H8.636ZM8.636 10.332V9.6H15.14V10.332H8.636Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1996_10345"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1996_10345" />
              </filter>
              <linearGradient
                id="paint0_linear_1996_10345"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "send-statement":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1996_10315)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1996_10315)" />
              <path
                d="M18 6H6C4.89543 6 4 6.89543 4 8V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V8C20 6.89543 19.1046 6 18 6Z"
                stroke="white"
                stroke-width="0.8"
              />
              <path
                d="M4 9L11.106 12.553C11.3836 12.6917 11.6897 12.7639 12 12.7639C12.3103 12.7639 12.6164 12.6917 12.894 12.553L20 9"
                stroke="white"
                stroke-width="0.8"
              />
              <path
                d="M11.3736 12.0161L5.29358 8.9761C5.04077 8.84991 4.83798 8.64203 4.71809 8.38617C4.5982 8.1303 4.56823 7.84145 4.63305 7.56642C4.69787 7.2914 4.85368 7.04633 5.07521 6.87093C5.29675 6.69554 5.57102 6.6001 5.85358 6.6001H18.1456C18.4281 6.6001 18.7024 6.69554 18.924 6.87093C19.1455 7.04633 19.3013 7.2914 19.3661 7.56642C19.4309 7.84145 19.401 8.1303 19.2811 8.38617C19.1612 8.64203 18.9584 8.84991 18.7056 8.9761L12.6256 12.0161C12.4312 12.1133 12.2169 12.1639 11.9996 12.1639C11.7823 12.1639 11.568 12.1133 11.3736 12.0161Z"
                fill="white"
                fill-opacity="0.25"
                stroke="white"
                stroke-width="0.8"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1996_10315"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1996_10315" />
              </filter>
              <linearGradient
                id="paint0_linear_1996_10315"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "send-payment-link":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1996_10230)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1996_10230)" />
              <g clip-path="url(#clip0_1996_10230)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4 5.65714C4 4.71429 4.79543 4 5.71429 4H18.2857C19.2046 4 20 4.71429 20 5.65714V12.0571C20 13 19.2046 13.7143 18.2857 13.7143H5.71429C4.79543 13.7143 4 13 4 12.0571V5.65714ZM14.2857 8.85714C14.2857 9.46335 14.0449 10.0447 13.6162 10.4734C13.1876 10.902 12.6062 11.1429 12 11.1429C11.3938 11.1429 10.8124 10.902 10.3838 10.4734C9.9551 10.0447 9.71429 9.46335 9.71429 8.85714C9.71429 8.25093 9.9551 7.66955 10.3838 7.2409C10.8124 6.81224 11.3938 6.57143 12 6.57143C12.6062 6.57143 13.1876 6.81224 13.6162 7.2409C14.0449 7.66955 14.2857 8.25093 14.2857 8.85714ZM8 9.14286C8 9.0303 7.97783 8.91884 7.93475 8.81484C7.89168 8.71085 7.82854 8.61636 7.74895 8.53677C7.66936 8.45717 7.57487 8.39404 7.47087 8.35096C7.36688 8.30789 7.25542 8.28571 7.14286 8.28571C7.0303 8.28571 6.91884 8.30789 6.81484 8.35096C6.71085 8.39404 6.61636 8.45717 6.53677 8.53677C6.45717 8.61636 6.39404 8.71085 6.35096 8.81484C6.30788 8.91884 6.28571 9.0303 6.28571 9.14286C6.28571 9.37019 6.37602 9.5882 6.53677 9.74895C6.69751 9.90969 6.91553 10 7.14286 10C7.37019 10 7.5882 9.90969 7.74895 9.74895C7.90969 9.5882 8 9.37019 8 9.14286ZM16.8571 8.28571C17.0845 8.28571 17.3025 8.37602 17.4632 8.53677C17.624 8.69751 17.7143 8.91553 17.7143 9.14286C17.7143 9.37019 17.624 9.5882 17.4632 9.74895C17.3025 9.90969 17.0845 10 16.8571 10C16.6298 10 16.4118 9.90969 16.2511 9.74895C16.0903 9.5882 16 9.37019 16 9.14286C16 8.91553 16.0903 8.69751 16.2511 8.53677C16.4118 8.37602 16.6298 8.28571 16.8571 8.28571ZM9.85714 16C9.85714 15.8106 9.78189 15.6289 9.64793 15.4949C9.51398 15.361 9.3323 15.2857 9.14286 15.2857C8.95342 15.2857 8.77174 15.361 8.63778 15.4949C8.50383 15.6289 8.42857 15.8106 8.42857 16V18.2857C8.42857 18.4752 8.50383 18.6568 8.63778 18.7908C8.77174 18.9247 8.95342 19 9.14286 19C9.3323 19 9.51398 18.9247 9.64793 18.7908C9.78189 18.6568 9.85714 18.4752 9.85714 18.2857V16ZM14.8571 15.2857C15.2514 15.2857 15.5714 15.6057 15.5714 16V18.2857C15.5714 18.3795 15.553 18.4724 15.5171 18.5591C15.4812 18.6457 15.4285 18.7245 15.3622 18.7908C15.2959 18.8571 15.2171 18.9097 15.1305 18.9456C15.0438 18.9815 14.9509 19 14.8571 19C14.7633 19 14.6705 18.9815 14.5838 18.9456C14.4971 18.9097 14.4184 18.8571 14.3521 18.7908C14.2857 18.7245 14.2331 18.6457 14.1972 18.5591C14.1613 18.4724 14.1429 18.3795 14.1429 18.2857V16C14.1429 15.6057 14.4629 15.2857 14.8571 15.2857ZM12 16.1429C12.3943 16.1429 12.7143 16.4629 12.7143 16.8571V19.1429C12.7143 19.3323 12.639 19.514 12.5051 19.6479C12.3711 19.7819 12.1894 19.8571 12 19.8571C11.8106 19.8571 11.6289 19.7819 11.4949 19.6479C11.361 19.514 11.2857 19.3323 11.2857 19.1429V16.8571C11.2857 16.4629 11.6057 16.1429 12 16.1429Z"
                  fill="white"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_i_1996_10230"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1996_10230" />
              </filter>
              <linearGradient
                id="paint0_linear_1996_10230"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
              <clipPath id="clip0_1996_10230">
                <rect width="16" height="16" fill="white" transform="translate(4 4)" />
              </clipPath>
            </defs>
          </svg>
        );
      case "add-payment":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="addCashGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="addCashShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                0 0 0 0 1
                0 0 0 0 1
                0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>
            <g filter="url(#addCashShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#addCashGradient)" />
              <g transform="translate(3, 4)">
                <rect x="1" y="3" width="16" height="10" rx="1.5" stroke="white" fill="none" />

                <text
                  x="7"
                  y="10"
                  fill="white"
                  font-size="6.5"
                  font-family="Arial, sans-serif"
                  font-weight="bold"
                >
                  ₹
                </text>

                <path d="M14.5 0V1.5H16V2.5H14.5V4H13.5V2.5H12V1.5H13.5V0H14.5Z" fill="white" />
              </g>
            </g>
          </svg>
        );
      case "cancel":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="cancelGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="cancelShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                0 0 0 0 1
                0 0 0 0 1
                0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>
            <g filter="url(#cancelShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#cancelGradient)" />
              <path
                d="M9 9L15 15M15 9L9 15"
                stroke="white"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </g>
          </svg>
        );
      case "view":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="viewGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="viewShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                0 0 0 0 1
                0 0 0 0 1
                0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>

            <g filter="url(#viewShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#viewGradient)" />
              <path
                d="M12.5 8C9.5 8 7.21 10.11 6.5 12C7.21 13.89 9.5 16 12.5 16C15.5 16 17.79 13.89 18.5 12C17.79 10.11 15.5 8 12.5 8Z
         M12.5 14C11.12 14 10 12.88 10 11.5C10 10.12 11.12 9 12.5 9C13.88 9 15 10.12 15 11.5C15 12.88 13.88 14 12.5 14Z"
                fill="white"
              />
            </g>
          </svg>
        );
      case "add-driver":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="addGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
              <filter
                id="addShadow"
                x="-1"
                y="-1"
                width="27"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feComposite in="SourceAlpha" in2="blur" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1
                        0 0 0 0 1
                        0 0 0 0 1
                        0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="SourceGraphic" result="innerShadow" />
              </filter>
            </defs>

            <g filter="url(#addShadow)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#addGradient)" />

              <g transform="translate(-3.5 -3.5) scale(1.4)">
                <path
                  d="M9.5 7C10.88 7 12 8.12 12 9.5C12 10.88 10.88 12 9.5 12C8.12 12 7 10.88 7 9.5C7 8.12 8.12 7 9.5 7Z
                   M6 15.5C6 14.12 7.12 13 8.5 13H10.5C11.88 13 13 14.12 13 15.5V16H6V15.5Z"
                  fill="white"
                />
              </g>

              <path
                d="M17 10V13M15.5 11.5H18.5"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </g>
          </svg>
        );
      case "pending-request":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1996_10889)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_1996_10889)" />
              <path
                opacity="0.3"
                d="M18.65 19.35L16.5 17.2V14H17.5V16.79L19.35 18.64L18.65 19.35ZM17 10C17.34 10 17.67 10.03 18 10.08V5H16V8H8V5H6V20H10.68C10.1726 18.9335 9.94357 17.7559 10.0141 16.577C10.0847 15.3981 10.4526 14.2563 11.0836 13.2579C11.7145 12.2596 12.588 11.4373 13.6225 10.8676C14.6571 10.2979 15.819 9.99943 17 10ZM12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5Z"
                fill="white"
              />
              <path
                d="M17 12C14.24 12 12 14.24 12 17C12 19.76 14.24 22 17 22C19.76 22 22 19.76 22 17C22 14.24 19.76 12 17 12ZM18.65 19.35L16.5 17.2V14H17.5V16.79L19.35 18.64L18.65 19.35ZM18 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H6C4.9 3 4 3.9 4 5V20C4 21.1 4.9 22 6 22H12.11C11.5176 21.4264 11.0362 20.7484 10.69 20H6V5H8V8H16V5H18V10.08C18.71 10.18 19.38 10.39 20 10.68V5C20 3.9 19.1 3 18 3ZM12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1996_10889"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1996_10889" />
              </filter>
              <linearGradient
                id="paint0_linear_1996_10889"
                x1="0.330274"
                y1="6.12959e-07"
                x2="23.6697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFCB5B" />
                <stop offset="1" stop-color="#FF9F18" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "filter-icon-inactive":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.50109 5H18.5011C18.7929 5.10236 19.021 5.33401 19.1188 5.62742C19.2166 5.92084 19.1732 6.243 19.0011 6.5L14.0011 12V19L10.0011 16V12L5.00109 6.5C4.82902 6.243 4.78555 5.92084 4.88335 5.62742C4.98116 5.33401 5.20923 5.10236 5.50109 5"
              stroke="#7E7E7E"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "filter-icon-active":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.50109 5H18.5011C18.7929 5.10236 19.021 5.33401 19.1188 5.62742C19.2166 5.92084 19.1732 6.243 19.0011 6.5L14.0011 12V19L10.0011 16V12L5.00109 6.5C4.82902 6.243 4.78555 5.92084 4.88335 5.62742C4.98116 5.33401 5.20923 5.10236 5.50109 5Z"
              fill="#4318FF"
            />
          </svg>
        );
      case "checkbox":
        return (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.91602 7.00016L5.83268 9.91683L11.666 4.0835"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "request-clock":
        return (
          <svg
            width="15.5"
            height="15.5"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 5.3335V8.00016L9.33333 9.3335"
              stroke="#616161"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.28706 7.25689C1.24509 7.66897 1.54512 8.03706 1.9572 8.07904C2.36928 8.12101 2.73737 7.82098 2.77934 7.4089L1.28706 7.25689ZM3.07101 9.74223C2.92889 9.35316 2.49828 9.15297 2.10921 9.29509C1.72014 9.43721 1.51994 9.86782 1.66206 10.2569L3.07101 9.74223ZM1.2832 13.3333C1.2832 13.7475 1.61899 14.0833 2.0332 14.0833C2.44742 14.0833 2.7832 13.7475 2.7832 13.3333H1.2832ZM2.0332 9.99995V9.24995C1.61899 9.24995 1.2832 9.58573 1.2832 9.99995H2.0332ZM5.36654 10.7499C5.78075 10.7499 6.11654 10.4142 6.11654 9.99995C6.11654 9.58573 5.78075 9.24995 5.36654 9.24995V10.7499ZM2.0332 7.3329L2.77934 7.4089C3.04997 4.75208 5.27196 2.72177 7.94235 2.69127L7.93379 1.94132L7.92522 1.19136C4.49186 1.23058 1.63502 3.84098 1.28706 7.25689L2.0332 7.3329ZM7.93379 1.94132L7.94235 2.69127C10.6128 2.66077 12.8805 4.6398 13.2118 7.28974L13.956 7.19672L14.7002 7.10369C14.2743 3.69662 11.3586 1.15215 7.92522 1.19136L7.93379 1.94132ZM13.956 7.19672L13.2118 7.28974C13.543 9.93969 11.8322 12.416 9.23642 13.0438L9.41272 13.7728L9.58903 14.5018C12.9264 13.6947 15.1261 10.5108 14.7002 7.10369L13.956 7.19672ZM9.41272 13.7728L9.23642 13.0438C6.64069 13.6716 3.9873 12.2507 3.07101 9.74223L2.36654 9.99956L1.66206 10.2569C2.84015 13.482 6.25165 15.3089 9.58903 14.5018L9.41272 13.7728ZM2.0332 13.3333H2.7832V9.99995H2.0332H1.2832V13.3333H2.0332ZM2.0332 9.99995V10.7499H5.36654V9.99995V9.24995H2.0332V9.99995Z"
              fill="#616161"
            />
          </svg>
        );
      case "Maintenance":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18039)">
              <rect
                x="0.666016"
                width="24"
                height="24"
                rx="4"
                fill="url(#paint0_linear_1822_18039)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.6654 3.66699C17.2602 3.66699 20.9987 7.40555 20.9987 12.0003C20.9987 16.5951 17.2602 20.3337 12.6654 20.3337C8.07059 20.3337 4.33203 16.5951 4.33203 12.0003C4.33203 7.40555 8.07059 3.66699 12.6654 3.66699ZM12.7011 8.17668C11.9107 7.57551 10.8775 7.3682 10.137 7.53566L11.419 8.8177L10.778 10.0997L9.49598 10.7408L8.21391 9.45875C8.04645 10.1992 8.25375 11.2324 8.85492 12.0228C9.67453 12.6532 10.6828 12.8659 11.419 12.6638L14.3436 15.4402C14.8982 15.9295 15.4528 15.8969 16.0074 15.3423C16.5966 14.7531 16.5966 14.1638 16.0074 13.5746C14.2053 11.8065 13.3169 10.8619 13.3421 10.7408C13.5441 10.0046 13.3314 8.99633 12.7011 8.17672"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18039"
                x="-0.333984"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18039" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18039"
                x1="0.99629"
                y1="6.12959e-07"
                x2="24.3357"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "collapse-arrow":
        return (
          <svg
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7L7 1L13 7"
              stroke="#616161"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );
      case "date-calender":
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="2.66797"
              y="3.3335"
              width="10.6667"
              height="10.6667"
              rx="1.33333"
              stroke="#4B465C"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <rect
              x="2.66797"
              y="3.3335"
              width="10.6667"
              height="10.6667"
              rx="1.33333"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.6654 2V4.66667"
              stroke="#4B465C"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.6654 2V4.66667"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.33333 2V4.66667"
              stroke="#4B465C"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.33333 2V4.66667"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.66797 7.33333H13.3346"
              stroke="#4B465C"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.66797 7.33333H13.3346"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <rect
              x="5.33203"
              y="10"
              width="1.33333"
              height="1.33333"
              stroke="#4B465C"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <rect
              x="5.33203"
              y="10"
              width="1.33333"
              height="1.33333"
              stroke="white"
              stroke-opacity="0.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "dropdown":
        return (
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 0.5C36.5604 0.5 43.5 7.43959 43.5 16V28C43.5 36.5604 36.5604 43.5 28 43.5H0.5V0.5H28Z"
              fill="white"
            />
            <path
              d="M28 0.5C36.5604 0.5 43.5 7.43959 43.5 16V28C43.5 36.5604 36.5604 43.5 28 43.5H0.5V0.5H28Z"
              stroke="#D3D3D3"
              // stroke="#9ca3af"
            />
            <path
              d="M16 19L22 25L28 19"
              stroke="#4B465C"
              stroke-width="1.125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 19L22 25L28 19"
              stroke="white"
              stroke-opacity="0.2"
              stroke-width="1.125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        );

      case "checkbox-active":
        return (
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_1920_7819)">
              <rect
                x="4"
                y="2"
                width="18"
                height="18"
                rx="4"
                fill="#4318FF"
                shape-rendering="crispEdges"
              />
              <path
                d="M8.91602 11.0002L11.8327 13.9168L17.666 8.0835"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_1920_7819"
                x="0"
                y="0"
                width="26"
                height="26"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.647059 0 0 0 0 0.639216 0 0 0 0 0.682353 0 0 0 0.3 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1920_7819"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_1920_7819"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        );
      case "checkbox-inactive":
        return (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.75"
              y="0.75"
              width="16.5"
              height="16.5"
              rx="3.25"
              stroke="#7E7E7E"
              stroke-width="1.5"
            />
          </svg>
        );

      case "avatar":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 13 16">
            <path
              fill={color}
              d="M4 10h5c1.66 0 3 1.34 3 3v2H1v-2c0-1.66 1.34-3 3-3m0-6h5v2.5a2.5 2.5 0 0 1-5 0zm5 0c.55 0 1 .45 1 1s-.45 1-1 1zM4 6c-.55 0-1-.45-1-1s.45-1 1-1z"
            />
            <path
              fill="currentColor"
              d="M4.12 4.12h-.5C2.87 3.5 3 2.55 3 1.75s.5-.26 1-.26s1 .5 1 .5c-.88 0-1-1-1-1h3c1.1 0 2 .9 2 2h.5s.25.75-.12 1.25l-5.25-.12Z"
            />
          </svg>
        );

      case "adjust-sd":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="bgGradient"
                x1="0"
                y1="0"
                x2="24"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <filter
                id="innerShadow"
                x="-1"
                y="-1"
                width="26"
                height="26"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 0.16 0"
                />
                <feBlend in2="shape" result="effect1_innerShadow" />
              </filter>
            </defs>

            <g filter="url(#innerShadow)">
              <rect width="24" height="24" rx="4" fill="url(#bgGradient)" />
              <path
                d="M5 8C5 7.44772 5.44772 7 6 7H18C18.5523 7 19 7.44772 19 8V16C19 16.5523 18.5523 17 18 17H6C5.44772 17 5 16.5523 5 16V8Z"
                fill="white"
              />
              <circle cx="12" cy="12" r="1.5" fill="#4318FF" />
              <path d="M8 9H9M15 15H16" stroke="#4318FF" strokeWidth="1.2" strokeLinecap="round" />
              <path
                d="M7 18H17V19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19V18Z"
                fill="white"
              />
            </g>
          </svg>
        );
      case "move_to_primary":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i)">
              <rect x="0.5" y="0" width="24" height="24" rx="4" fill="url(#paint0_linear)" />

              {/* Enlarged head */}
              <circle cx="10.7" cy="8.5" r="3.2" fill="white" />

              {/* Enlarged body */}
              <path
                d="M6 17C6 14.5 8 12.5 10.7 12.5H11C13.5 12.5 15.5 14.5 15.5 17V18H6V17Z"
                fill="white"
              />

              {/* Enlarged vertical arrow line */}
              <path d="M17 16.5V10" stroke="white" strokeWidth="2.2" strokeLinecap="round" />

              {/* Enlarged arrow head */}
              <path
                d="M15.2 12L17 10.2L18.8 12"
                stroke="white"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_i"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
              </filter>
              <linearGradient
                id="paint0_linear"
                x1="0.830274"
                y1="0"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "move_to_secondary":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i)">
              <rect x="0.5" y="0" width="24" height="24" rx="4" fill="url(#paint0_linear)" />
              {/* Head */}
              <circle cx="10.7" cy="8.5" r="3.2" fill="white" />
              {/* Body */}
              <path
                d="M6 17C6 14.5 8 12.5 10.7 12.5H11C13.5 12.5 15.5 14.5 15.5 17V18H6V17Z"
                fill="white"
              />
              {/* Arrow pointing down */}{" "}
              <path d="M18 9V16.5" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
              <path
                d="M16.2 15L18 16.8L19.8 15"
                stroke="white"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_i"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
              </filter>
              <linearGradient
                id="paint0_linear"
                x1="0.830274"
                y1="0"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "add-payment2":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_cash_icon)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_cash_icon)" />
              <g clipPath="url(#clip0_cash_icon)">
                <rect x="5" y="7" width="14" height="10" rx="2" fill="white" />
                <rect x="7" y="9" width="10" height="6" rx="1" fill="#868CFF" />

                <circle cx="12" cy="12" r="1.5" fill="white" />

                <path d="M18 6V10M16 8H20" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_i_cash_icon"
                x="-1"
                y="-1"
                width="26"
                height="26"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_cash_icon" />
              </filter>
              <linearGradient
                id="paint0_linear_cash_icon"
                x1="0"
                y1="0"
                x2="24"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
              <clipPath id="clip0_cash_icon">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      case "Penalty":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_1822_18029)">
              <rect x="0.5" width="24" height="24" rx="4" fill="url(#paint0_linear_1822_18029)" />
              <path
                opacity="0.5"
                d="M5 10.3337C5 7.19116 5 5.61949 5.97667 4.64366C6.95333 3.66783 8.52417 3.66699 11.6667 3.66699H13.3333C16.4758 3.66699 18.0475 3.66699 19.0233 4.64366C19.9992 5.62033 20 7.19116 20 10.3337V13.667C20 16.8095 20 18.3812 19.0233 19.357C18.0467 20.3328 16.4758 20.3337 13.3333 20.3337H11.6667C8.52417 20.3337 6.9525 20.3337 5.97667 19.357C5.00083 18.3803 5 16.8095 5 13.667V10.3337Z"
                fill="white"
              />
              <path
                d="M16.2663 15.7513C16.4122 15.6379 16.5447 15.5054 16.8088 15.2413L20.1063 11.9429C20.1863 11.8638 20.1497 11.7263 20.0438 11.6888C19.5274 11.5098 19.0588 11.215 18.6738 10.8271C18.2859 10.4421 17.9912 9.97349 17.8122 9.45709C17.7747 9.35125 17.6372 9.31459 17.558 9.39459L14.2588 12.6921C13.9947 12.9563 13.8622 13.0888 13.7488 13.2346C13.6138 13.4074 13.4994 13.5924 13.4055 13.7896C13.3263 13.9563 13.2672 14.1346 13.1488 14.4896L12.9955 14.9479L12.7522 15.6771L12.5247 16.3604C12.4963 16.4461 12.4923 16.5379 12.5131 16.6257C12.5339 16.7135 12.5787 16.7938 12.6425 16.8576C12.7063 16.9214 12.7866 16.9662 12.8744 16.987C12.9622 17.0078 13.054 17.0038 13.1397 16.9754L13.823 16.7479L14.5522 16.5046L15.0105 16.3513C15.3655 16.2329 15.5438 16.1746 15.7105 16.0946C15.9077 16.0001 16.0936 15.8857 16.2663 15.7513ZM21.1397 10.9104C21.4777 10.5723 21.6676 10.1137 21.6675 9.63554C21.6674 9.1574 21.4774 8.69888 21.1393 8.36084C20.8011 8.0228 20.3425 7.83293 19.8644 7.83301C19.3862 7.83309 18.9277 8.0231 18.5897 8.36125L18.4847 8.46792C18.434 8.51749 18.3962 8.57874 18.3747 8.6463C18.3532 8.71386 18.3486 8.78567 18.3613 8.85542C18.378 8.94459 18.4072 9.07625 18.4613 9.23209C18.5697 9.54459 18.7747 9.95459 19.1605 10.3404C19.5463 10.7263 19.9563 10.9313 20.2688 11.0396C20.4255 11.0938 20.5563 11.1229 20.6455 11.1396C20.7153 11.1516 20.7869 11.1466 20.8543 11.1252C20.9217 11.1037 20.983 11.0664 21.033 11.0163L21.1397 10.9104Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.54102 9.5C8.54102 9.33424 8.60686 9.17527 8.72407 9.05806C8.84128 8.94085 9.00026 8.875 9.16602 8.875H14.5827C14.7484 8.875 14.9074 8.94085 15.0246 9.05806C15.1418 9.17527 15.2077 9.33424 15.2077 9.5C15.2077 9.66576 15.1418 9.82473 15.0246 9.94194C14.9074 10.0592 14.7484 10.125 14.5827 10.125H9.16602C9.00026 10.125 8.84128 10.0592 8.72407 9.94194C8.60686 9.82473 8.54102 9.66576 8.54102 9.5ZM8.54102 12.8333C8.54102 12.6676 8.60686 12.5086 8.72407 12.3914C8.84128 12.2742 9.00026 12.2083 9.16602 12.2083H11.666C11.8318 12.2083 11.9907 12.2742 12.108 12.3914C12.2252 12.5086 12.291 12.6676 12.291 12.8333C12.291 12.9991 12.2252 13.1581 12.108 13.2753C11.9907 13.3925 11.8318 13.4583 11.666 13.4583H9.16602C9.00026 13.4583 8.84128 13.3925 8.72407 13.2753C8.60686 13.1581 8.54102 12.9991 8.54102 12.8333ZM8.54102 16.1667C8.54102 16.0009 8.60686 15.8419 8.72407 15.7247C8.84128 15.6075 9.00026 15.5417 9.16602 15.5417H10.416C10.5818 15.5417 10.7407 15.6075 10.858 15.7247C10.9752 15.8419 11.041 16.0009 11.041 16.1667C11.041 16.3324 10.9752 16.4914 10.858 16.6086C10.7407 16.7258 10.5818 16.7917 10.416 16.7917H9.16602C9.00026 16.7917 8.84128 16.7258 8.72407 16.6086C8.60686 16.4914 8.54102 16.3324 8.54102 16.1667Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_1822_18029"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1822_18029" />
              </filter>
              <linearGradient
                id="paint0_linear_1822_18029"
                x1="0.830274"
                y1="6.12959e-07"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#868CFF" />
                <stop offset="1" stop-color="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );

      case "assign-car":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_assign)">
              <rect width="24" height="24" rx="4" fill="url(#paint0_linear_assign)" />
              <path
                d="M6.5 15C6.22386 15 6 15.2239 6 15.5C6 15.7761 6.22386 16 6.5 16C6.77614 16 7 15.7761 7 15.5C7 15.2239 6.77614 15 6.5 15ZM17.5 15C17.2239 15 17 15.2239 17 15.5C17 15.7761 17.2239 16 17.5 16C17.7761 16 18 15.7761 18 15.5C18 15.2239 17.7761 15 17.5 15ZM5 12L6.5 8H17.5L19 12H5ZM4 12.5H20V13.5H19.5L18.5 16.5H5.5L4.5 13.5H4V12.5ZM13 6H11V4H13V6ZM10 6H8V4H10V6ZM16 6H14V4H16V6Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_i_assign"
                x="-1"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_assign" />
              </filter>
              <linearGradient
                id="paint0_linear_assign"
                x1="0.33"
                y1="0"
                x2="23.67"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );
      case "time-icon":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="currentColor"
            viewBox="0 0 24 24"
            className="text-gray-500"
          >
            <path d="M12 8v5h4v-2h-2V8z" />
            <path d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1zm0 20c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9-4.03 9-9 9z" />
          </svg>
        );
      case "complete":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2l4-4m6 2a9 9 0 1 1-18 0a9 9 0 0 1 18 0z"
            />
          </svg>
        );

      case "in_workshop":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i)">
              {/* Background */}
              <rect x="0.5" y="0" width="24" height="24" rx="4" fill="url(#paint0_linear)" />

              {/* Wrench / Spanner icon */}
              <path
                d="M15.5 7.5C15.5 6.1 14.4 5 13 5C12.5 5 12.1 5.1 11.7 5.3L13.2 6.8L11.8 8.2L10.3 6.7C10.1 7.1 10 7.5 10 8C10 9.4 11.1 10.5 12.5 10.5C12.8 10.5 13.1 10.4 13.3 10.3L16.7 13.7C16.9 13.9 16.9 14.2 16.7 14.4L15.4 15.7C15.2 15.9 14.9 15.9 14.7 15.7L11.3 12.3C11.2 12.1 11.1 11.8 11.1 11.5C11.1 10.1 10 9 8.6 9C8.1 9 7.7 9.1 7.3 9.3L8.8 10.8L7.4 12.2L5.9 10.7C5.7 11.1 5.6 11.5 5.6 12C5.6 13.4 6.7 14.5 8.1 14.5C8.4 14.5 8.7 14.4 8.9 14.3L12.3 17.7C13.1 18.5 14.3 18.5 15.1 17.7L17.2 15.6C18 14.8 18 13.6 17.2 12.8L13.8 9.4C13.9 9.2 14 8.9 14 8.6C14 7.7 13.3 7 12.4 7C11.9 7 11.5 7.2 11.2 7.5"
                fill="white"
              />
            </g>

            {/* Filters & Gradient */}
            <defs>
              <filter
                id="filter0_i"
                x="-0.5"
                y="-1"
                width="25"
                height="25"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" dy="-1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
              </filter>
              <linearGradient
                id="paint0_linear"
                x1="0.830274"
                y1="0"
                x2="24.1697"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
            </defs>
          </svg>
        );

      case "maintenance-sidebar-icon":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 26 26">
            <path
              fill={color}
              d="M1.313 0L0 1.313l2.313 4l1.5-.22l9.156 9.157l-.781.75c-.4.4-.4 1.006 0 1.406l.406.407c.4.4 1.012.4 1.312 0L15.094 18c-.1.6 0 1.313.5 1.813L21 25.188c1.1 1.1 2.9 1.1 4 0c1.3-1.2 1.288-2.994.188-4.094l-5.375-5.407c-.5-.5-1.213-.7-1.813-.5L16.687 14c.3-.4.3-1.012 0-1.313l-.375-.374a.974.974 0 0 0-1.406 0l-.656.656l-9.156-9.156l.218-1.5l-4-2.313zm19.5.031C18.84-.133 16.224 1.175 15 2.312c-1.506 1.506-1.26 3.475-.063 5.376l-2.124 2.125l1.5 1.687c.8-.7 1.98-.7 2.78 0l.407.406l.094.094l.875-.875c1.808 1.063 3.69 1.216 5.125-.219c1.4-1.3 2.918-4.506 2.218-6.406L23 7.406c-.4.4-1.006.4-1.406 0L18.687 4.5a.974.974 0 0 1 0-1.406L21.595.188c-.25-.088-.5-.133-.782-.157m-11 12.469l-3.626 3.625A5.3 5.3 0 0 0 5 16c-2.8 0-5 2.2-5 5s2.2 5 5 5s5-2.2 5-5c0-.513-.081-1.006-.219-1.469l2.125-2.125l-.312-.406c-.8-.8-.794-2.012-.094-2.813L9.812 12.5zm7.75 4.563c.125 0 .243.024.343.125l5.907 5.906c.2.2.2.518 0 .718s-.52.2-.72 0l-5.905-5.906c-.2-.2-.2-.518 0-.718c.1-.1.25-.125.375-.125M5.688 18.405l1.906 1.907l-.688 2.593l-2.593.688l-1.907-1.907l.688-2.593z"
            />
          </svg>
        );
      case "child-hub":
        return (
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="childHubGradient"
                x1="0"
                y1="0"
                x2="25"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#868CFF" />
                <stop offset="1" stopColor="#4318FF" />
              </linearGradient>
            </defs>

            {/* Background */}
            <rect x="0.25" width="24" height="24" rx="4" fill="url(#childHubGradient)" />

            {/* Home + Arrow */}
            <g transform="translate(0.4, 1.6) scale(1.05)">
              {/* FIXED — HOUSE BASE STRAIGHT */}
              <path
                d="
                  M4.5 16
                  V10.2
                  L12 4
                  L18 10.2
                  V16
                  H6
                  Z
                "
                fill="none"
                stroke="white"
                strokeWidth="1.4"
                strokeLinejoin="round"
              />

              {/* WINDOW LEFT */}
              <rect
                x="8.1"
                y="11.2"
                width="2.1"
                height="2.1"
                fill="none"
                stroke="white"
                strokeWidth="1.2"
                rx="0.4"
              />

              {/* WINDOW RIGHT */}
              <rect
                x="12.9"
                y="11.2"
                width="2.1"
                height="2.1"
                fill="none"
                stroke="white"
                strokeWidth="1.2"
                rx="0.4"
              />

              {/* BIG ARROW → */}
              <path d="M18.3 12H22" stroke="white" strokeWidth="1.6" strokeLinecap="round" />
              <path
                d="M20.8 10.5L22.8 12L20.8 13.5"
                stroke="white"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );

      default:
        return null;
    }
  };
  return <div className={className}>{renderIcon()}</div>;
};
